import Vue from 'vue'
import Vuex from 'vuex'
import { db } from '@/main'
import { ecommerce } from 'vue-analytics'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    priceMultiplicator: 1.3,
    language: "DE",
    voucher: {
      vouchers: [
          { code:"kauf-per-überweisung", used:false, value: 0},
          { code:"hoelzelandfriends", used: false, value: 50}
        ],
      voucherAccepted: false
    },
    footer: true,
    animationProperties: {
      vertical: true,
      mobile: false,
      radius: 300,
      beta: 1.2,
      alpha: 2,
      defaults: {
        mobile: {
          radius: 400,
          beta: 1.0,
          alpha: 2.8,
        },
        desktop: {
          radius: 300,
          beta: 1.2,
          alpha: 2,
        }
      }
    },
    sustainabilityNumbers: {
      planksUsed: 97,
      treesPlanted: 22,
      electricityUsed: 2560
    },
    navbarActive: [true, false, false, false, false, false],
    shippingAndDiscount: {
      discountOnMultipleItems: 0.1,
      shippingCostLow: 35,
      shippingCostLowThreshhold: 250,
      shippingCostMedium: 50,
      shippingCostMediumThreshhold: 500,
      shippingCostNormal: 75,
      shippingCost: 75
    },
    tableConfig: {
      dimensions: {
        chosen: 'individual',
        costForIndividual: 30,
        standardDimensions: {
          dining: {
            length: 200,
            width: 95,
            height: 75
          },
          office: {
            length: 160,
            width: 80,
            height: 70
          },
          sofa: {
            length: 120,
            width: 60,
            height: 45
          },
        },
        length: 220,
        width: 80,
        height: 75
      },
      tableTop: 'single',
      tableTopTypes: {
        single: 0,
        solid: 150,
      },
      frameType: 'open',
      frameTypes: {
        open: 0,
        closed: 75,
        diagonal: 125
      },
      color: {
        chooseOwnColor: false,
        costForSelfPicking: 100,
        hex: '#27292B',
        name: 'Graphit',
        ral: '',
        appearance: 'matt',
      },
      planks:{
        used: [
          {index: NaN, downArrow: false, upArrow: false, active: true},
          {index: NaN, downArrow: false, upArrow: false, active: true},
          {index: NaN, downArrow: false, upArrow: false, active: true},
          {index: NaN, downArrow: false, upArrow: false, active: true}
        ],
        availablePlanks: [],
        availablePlanksTitle: [],
        choosePlanks:true,
        numberOfPlanks: 3,
        costForSelfPicking: 30,
      },
      baseprice: 599,
      price: 599,
    },
    tableOfficeConfig: {
      dimensions: {
        length: 160,
        width: 80,
        height: 75
      },
      color: {
        chooseOwnColor: false,
        costForSelfPicking: 100,
        hex: '#27292B',
        name: 'Graphit',
        ral: '',
        appearance: 'matt',
      },
      planks:{
        used: [
          {index: NaN, downArrow: false, upArrow: false, active: true}
        ],
        availablePlanks: [],
        availablePlanksTitle: [],
        choosePlanks:true,
      },
      baseprice: 1399,
      price: 1399,
    },
    shelfConfig: {
      dimensions: {
        width: 200,
        depth: 30,
        height: 200,
        numberOfPillows: 3,
        plankThikness: 4,
        pillowThikness: 1,
        pillowWidth: 6,
        distanceLeftMiddle: 80,
        distanceOutsideToPillow: 10,
        minDistanceFor3Pillows: 99,
        // numberOfPlanks: 4,
        // planks: [
        //   {distanceFromTop:20, leftShort:false, rightShort:false},
        //   {distanceFromTop:33.5, leftShort:false, rightShort:false},
        //   {distanceFromTop:33.5, leftShort:false, rightShort:false},
        //   {distanceFromTop:33.5, leftShort:false, rightShort:false}],
        distanceTopToFirstPlank: 10,
      },
      planks:{
        used: [
          {distanceFromTop:20, leftShort:false, rightShort:false, index: NaN, downArrow: false, upArrow: false, active: true},
          {distanceFromTop:20, leftShort:false, rightShort:false, index: NaN, downArrow: false, upArrow: false, active: true},
          {distanceFromTop:20, leftShort:false, rightShort:false, index: NaN, downArrow: false, upArrow: false, active: true},
          {distanceFromTop:20, leftShort:false, rightShort:false, index: NaN, downArrow: false, upArrow: false, active: true},
          {distanceFromTop:20, leftShort:false, rightShort:false, index: NaN, downArrow: false, upArrow: false, active: false},
          {distanceFromTop:20, leftShort:false, rightShort:false, index: NaN, downArrow: false, upArrow: false, active: false},
          {distanceFromTop:20, leftShort:false, rightShort:false, index: NaN, downArrow: false, upArrow: false, active: false},
          {distanceFromTop:20, leftShort:false, rightShort:false, index: NaN, downArrow: false, upArrow: false, active: false},
          {distanceFromTop:20, leftShort:false, rightShort:false, index: NaN, downArrow: false, upArrow: false, active: false},
          {distanceFromTop:20, leftShort:false, rightShort:false, index: NaN, downArrow: false, upArrow: false, active: false}
        ],
        active:{
          numberOfPlanks: 6,
          numberOfPlanksInit: 6,
          planks: [
            {distanceFromTop:15, distanceToBelow: 26, leftShort:false, rightShort:true, index: NaN, downArrow: true, upArrow: true},
            {distanceFromTop:46, distanceToBelow: 26, leftShort:false, rightShort:true, index: NaN, downArrow: true, upArrow: true},
            {distanceFromTop:77, distanceToBelow: 26, leftShort:false, rightShort:false, index: NaN, downArrow: true, upArrow: true},
            {distanceFromTop:108, distanceToBelow: 26, leftShort:false, rightShort:false, index: NaN, downArrow: true, upArrow: true},
            {distanceFromTop:139, distanceToBelow: 26, leftShort:false, rightShort:false, index: NaN, downArrow: true, upArrow: true},
            {distanceFromTop:190, distanceToBelow: 26, leftShort:false, rightShort:false, index: NaN, downArrow: true, upArrow: true},
          ],
        },
        availablePlanks: [],
        availablePlanksTitle: [],
        choosePlanks:true,
        numberOfPlanksAvailable: 10,
        numberOfPlanks: 10,
        costForSelfPicking: 30,
      },
      frameType: 'open',
      frameTypes: {
        open: 0,
        closed: 75,
        diagonal: 125
      },
      color: {
        chooseOwnColor: false,
        costForSelfPicking: 100,
        hex: '#27292B',
        name: 'Graphit',
        ral: '',
        appearance: 'matt',
      },
      baseprice: 250,
      price: 599,
    },
    benchConfig: {
      dimensions: {
        chosen: 'individual',
        costForIndividual: 20,
        standardDimensions: {
          twoPerson: {
            length: 120,
            width: 40,
            height: 45
          },
          threePerson: {
            length: 170,
            width: 40,
            height: 45
          }
        },
        length: 220,
        width: 40,
        height: 45
      },
      frameType: 'simple',
      frameTypes: {
        simple: 0,
        massive: 50
      },
      color: {
        chooseOwnColor: false,
        costForSelfPicking: 100,
        hex: '#27292B',
        name: 'Graphit',
        ral: '',
        appearance: 'matt',
      },
      planks:{
        used: [{index: NaN, downArrow: false, upArrow: false, active: true}],
        availablePlanks: [],
        availablePlanksTitle: [],
        choosePlanks:true,
        costForSelfPicking: 25,
      },
      baseprice: 399,
      price: 399,
    },
    stoolConfig: {
      dimensions: {
        chosen: 'normal',
        costForIndividual: 10,
        standardDimensions: {
          normal: {
            length: 40,
            width: 40,
            height: 45
          },
          high: {
            length: 40,
            width: 40,
            height: 75
          }
        },
        length: 40,
        width: 40,
        height: 45
      },
      frameType: 'simple',
      frameTypes: {
        simple: 0,
        massive: 50
      },
      color: {
        chooseOwnColor: false,
        costForSelfPicking: 100,
        hex: '#27292B',
        name: 'Graphit',
        ral: '',
        appearance: 'matt',
      },
      planks:{
        used: [{index: NaN, downArrow: false, upArrow: false, active: true}],
        availablePlanks: [],
        availablePlanksTitle: [],
        choosePlanks:true,
        costForSelfPicking: 25,
      },
      baseprice: 149,
      price: 199,
    },
    frameConfig: {
      dimensions: {
        //20-150
        width: 40,
        //20-150
        height: 60
      },
      filling: {
        type: "none",
        mirror: {additionalPriceFaktor: 1.5, color: "#DDDDDD" },
        blackboard: {additionalPriceFaktor: 1.3, color: "#000000" },
        whiteboard: {additionalPriceFaktor: 1.4, color: "#FFFFFF" },
        passepartout: {additionalPriceFaktor: 1.2, color: "#000000" },
        none: {additionalPriceFaktor: 1}
      },
      baseprice: 40,
      price: 40,
    },
    sample: {
      price: 5,
    },
    standardColors: [
      {
        hex: '#27292B',
        name: 'Graphit',
        appearance: 'matt',
        price: 0,
        textPrice: '',
        ral: 'RAL 9011',
        textColor: '#EEEEEE',
        img: require('./../../public/img/gerüstbohlen-möbel-farbe-beispiel-graphit.jpeg')
      },
      {
        hex: '#FFFFFF',
        name: 'Weiß',
        appearance: 'matt',
        price: 0,
        textPrice: '',
        ral: 'RAL 9016',
        textColor: '#003157',
        img: require('./../../public/img/gerüstbohlen-möbel-farbe-beispiel-weiss.jpeg')
      },
      {
        hex: '#383430',
        name: 'Roh',
        appearance: 'matt',
        price: 0,
        textPrice: '',
        ral: 'klar',
        textColor: '#383430',
        img: require('./../../public/img/gerüstbohlen-möbel-farbe-beispiel-roh.jpeg')
      }
    ],
    order: {
      stripeID:'',
      customer: {
        firstName:'',
        lastName:'',
        email:'',
        street:'',
        zip:'',
        city:'',
        phone:'',
        message:'',
        voucher:'',
        voucherSum:0,
        shipping:true,
        invoice: false,
        outsideGermany: false,
        expressBuild: "expressBuildNo"
      },
      totalPrice:0.0,
      date:'',
      utm:'',
      products:[],
      orderID: 0,
      paypalPriceString: "599.00"
    },
    texts: {
      sample: {
        title: "Muster bestellen",
        text: "Du möchtest das Holz der Gerüstbohlen gerne anfassen und genauer sehen können? Gerne schicken wir dir für nur 5€ inkl. Versand ein Muster zu. Dieses kannst du auch als praktischen Tablethalter einsetzen",
        link: "Muster bekommen",
        popupTitle: "Dein Musterstück ist im warenkorb",
        popupText: "Gehe zum Warenkorb und trage dort deine Adresse ein. Anschliessend kannst du das Musterstück bezahlen und erhältst es wenige Tage später.",
        popupLabel: "Adresse",
        popupButtonDone: "Zum Warenkorb",
        popupButtonCancel: "Zurück",
        // thankYou: "Hat alles geklappt. Wir sind bis zum 15.10.2021 im Urlaub. Danach schicken wir dir sofort dein Musterstück zu."
        thankYou: "Hat alles geklappt. In ein paar Tagen bekommst du das Muster zugeschickt."
      },
      configurator: {
        title: "Welches Möbelstück möchtest du konfigurieren?",
        table: "Tisch",
        tableOffice: "Schreibtisch",
        bench: "Bank",
        shelf: "Regal",
        stool: "Hocker",
        frameProduct: "Rahmen",
        questions: {
          title1: "Hast du Fragen ",
          title2: "zum Konfigurator?",
          text: "Schreibe uns hier deine Frage und wir melden uns baldmöglichst bei dir.",
          message: "Deine Nachricht",
          contact: "Wie können wir dich erreichen?",
          contactForm: "Telefon oder E-Mail",
          send: "Senden",
          close: "Schliessen",
          thankYou: "Vielen Dank für deine Nachricht, wir melden uns in Kürze bei dir."
        },
        color: {
          title: "Gestellfarbe",
          titleFrame: "Passepartout Farbe",
          standardColor: "Wähle eine Standardfarbe ...",
          CheckboxText: "oder suche sie selbst aus",
          colorInfo: {
            button: "info",
            popupTitle: "Standardfarben Beispielbilder",
          }
        },
        frame: {
          title: "Gestelltyp",
          titleFrame: "Was kommt in den Rahmen?",
          open: "Offen",
          closed: "Geschlossen",
          simple: "Einfach",
          massiv: "Massiv",
          mirror: "Spiegel",
          whiteboard: "Whiteboard",
          blackboard: "Tafel",
          passepartout: "Passepartout",
          none: "Leer"
        },
        priceChip: {
          table: "Dein Tisch ",
          tableOffice: "Dein Schreibtisch ",
          shelf: "Dein Regal ",
          bench: "Deine Bank ",
          stool: "Dein Hocker ",
          delivery: "Gratis Lieferung ins Wohnzimmer",
          deliveryMobile1: "Gratis Lieferung",
          deliveryMobile2: "bis ins Wohnzimmer"
        },
        reviews: {
          dimensions: "L x B x H: "
        },
        dimensions: {
          title: "Maße",
          individual: "Individuell",
          dining: "Esstisch",
          office: "Schreibtisch",
          bench2person: "2 Personen",
          bench3person: "3 Personen",
          stoolNormal: "Normal",
          stoolHigh: "Hoch",
          length: "Länge: ",
          width: "Breite: ",
          height: "Höhe: ",
          numberOfPlanks1: "mit",
          numberOfPlanks2: "Gerüstbohlen",

        },
        wood: {
          title: "Gerüstbohlen",
          numberOfAvailablePlanks1: "Aktuell sind",
          numberOfAvailablePlanks2: "Gerüstbohlen verfügbar.",
          numberOfAvailablePlanksBoard: "Platten aus Gerüstbohlen verfügbar.",
          choiceOfPlanks: "Deine Wahl:"
        }
      },
      tableConfigurator: {
        configurator : {
          chooseWood: {
            title: "Gerüstbohlen",
            abovePlanks: "Jedes Brett wurde fotografiert, damit du genau auswählen kannst, welches für deinen Tisch eingesetzt werden soll.",
            abovePlanksTitle: "Wähle jede Gerüstbohle individuell",
            planksSingle: "Gerüstbohlen einzeln montiert (ca. 1mm Spalt)",
            planksSolid: "Gerüstbohlen einheitlich verleimt"
          },
          addedToCart: {
            title1: "Tisch zum Warenkorb",
            title2: "hinzugefügt",
            info: "Dein Tisch wurde erfolgreich zum Warenkorb hinzu gefügt. Wir bieten passend hierzu auch Hocker und Bänke an. Diese lassen sich genauso komfortabel konfigurieren wie der Tisch. Und bei mehreren Produkten gibt es auf alle günstigeren Möbestücke 10% Mengenrabatt.",
            close: "Schliessen",
            furtherProducts: "Weitere Produkte",
            furtherProductsMobile: "Produkte",
            toCart: "Zum Warenkorb",
            toCartMobile: "Warenkorb"
          },
          startConfigurator: "Konfigurator starten",
          backgroundInfo: "Mehr zu unseren Tischen",
          reviews: "Rezensionen"
        },
        backgroundInfo: "Mehr zu unseren Tischen",
        infoTeaser:"Ob Schreibtisch, Esstisch oder Küchentisch - mit unserem Konfigurator kannst du dir ganz einfach einen Tisch mit deinen Wunschmaßen erstellen.",
        infoSizeTitle:"Größe:",
        infoSizeText: "Wähle die passende Höhe, Breite und Tiefe - passend für deine Küche, Ess- oder Wohnzimmer. Bei einer Länge von 1,80m passen ungefähr 3 Stühle (ohne Armlehne)  nebeneinander, 2 Personen finden an 1,30m bequem Platz.",
        infoPlanksTitle: "Die Gerüstbohlen:",
        infoPlanksText: "Unsere Tische bestehen aus alten Gerüstbohlen, die wir von unserem Partner aus Brandenburg aufkaufen und aufarbeiten. Jede Bohle ist mit ihren Abnutzungsspuren und Farbklecksen einzigartig und macht jedes Möbelstück zu einem Unikat. Größere Risse werden mit speziellem Holzfüller aufgefüllt.",
        infoFrameTitle: "Das Gestell:",
        infoFrameText1: "Unsere Gestelle bestehen aus lackierten Stahl und sind verfügbar in  verschiedenen Farben. Wähle aus dem Farbfächer deine Lieblingsfarbe aus und setze bunte Akzente in deinem Zuhause. Wir bieten derzeit zwei verschiedene Beingestelle an - eine offene und eine geschlossene Variante.",
        infoFrameText2: "Für Sonderwünsche kontaktiere uns gerne per E-Mail und wir schauen, was sich machen lässt. Jedes Möbelstück wird individuell von Hand in unserer Werkstatt in Berlin gefertigt und ist spätestens 8 Wochen nach Auftragseingang bei dir. Die Lieferung erfolgt mit unserem Speditionspartner zu deinem Wunschtermin. Es ist außerdem möglich deinen Tisch persönlich in unserer Werkstatt abzuholen.",
        bulletpoints: ["Für jede Bestellung wird ein Baum gepflanzt",
                        "Upcycling ist nachhaltig",
                        "Jede Gerüstbohle ist individuell",
                        "10% Preisnachlass bei mehreren Produkten",
                        "Mit Liebe handgefertigt in Berlin",
                        "Gratis Versand bis in die Wohnung"],
      },
      tableOfficeConfigurator: {
        configurator : {
          chooseWood: {
            title: "Tischplatte aus Gerüstbohlen",
            abovePlanks: "Jede Tischplatte wurde fotografiert, damit du genau auswählen kannst, welche richtig für dich ist.",
            abovePlanksTitle: "Wähle deine Tischplatte"
          },
          addedToCart: {
            title1: "Tisch zum Warenkorb",
            title2: "hinzugefügt",
            info: "Dein Tisch wurde erfolgreich zum Warenkorb hinzu gefügt. Wir bieten passend hierzu auch Hocker und Bänke an. Diese lassen sich genauso komfortabel konfigurieren wie der Tisch. Und bei mehreren Produkten gibt es auf alle günstigeren Möbestücke 10% Mengenrabatt.",
            close: "Schliessen",
            furtherProducts: "Weitere Produkte",
            furtherProductsMobile: "Produkte",
            toCart: "Zum Warenkorb",
            toCartMobile: "Warenkorb"
          },
          startConfigurator: "Konfigurator starten",
          backgroundInfo: "Mehr zu unseren Schreibtischen",
          reviews: "Rezensionen"
        },
        backgroundInfo: "Mehr zu unseren Schreibtischen",
        infoTeaser:"Der höhenverstellbare Schreibtisch von rho 17 zeichnet sich durch seine einzigartige, nachhaltige Arbeitsfläche aus.",
        infoSizeTitle:"Tischplatte:",
        infoSizeText: "Die Platte besteht aus alten, aufgearbeiteten Gerüstbohlen, die zu einer planen Fläche verleimt wurden und einen warmen, gemütlichen Look in Dein Büro oder Home Office zaubern. ",
        infoPlanksTitle: "Die Gerüstbohlen:",
        infoPlanksText: "Jede Gerüstbohle erzählt eine Geschichte. Sie sind nicht perfekt, sie haben Abnutzungsspuren, aber gerade das macht sie so einzigartig schön. Die Bohlen bestehen aus verschiedenen robusten Nadelhölzern, meist Kiefer oder Fichte, und werden in unserer Werkstatt aufgearbeitet und für ihren neuen Einsatz vorbereitet. (Da es sich um natürlich gealtertes Holz handelt, können leichte Unebenheiten entstehen, die aber kaum spürbar sind.)",
        infoFrameTitle: "Das Gestell:",
        infoFrameText1: "Das Gestell lässt sich in der Höhe elektronisch zwischen 65 und 125 cm regulieren, um eine ergonomisch richtige Arbeitshaltung zu erlangen. So lässt es sich nicht nur bequem im Sitzen arbeiten, sondern eben auch im Stehen. Erhältlich ist das Gestell in den Farben Weiß und Schwarz. Es handelt sich dabei um ein Gestell von IKEA, was einen günstigen Preis und eine leichte Montage ermöglicht.",
        bulletpoints: ["Für jede Bestellung wird ein Baum gepflanzt",
                        "Upcycling ist nachhaltig",
                        "Jede Gerüstbohle ist individuell",
                        "10% Preisnachlass bei mehreren Produkten",
                        "Mit Liebe handgefertigt in Berlin",
                        "Gratis Versand bis in die Wohnung"],
      },
      shelfConfigurator: {
        configurator : {
          chooseWood: {
            title: "Gerüstbohlen",
            abovePlanks: "Jedes Brett wurde fotografiert, so kannst du genau auswählen welches für dein Regal eingesetzt werden soll.",
            abovePlanksTitle: "Wähle jede Gerüstbohle individuell"
          },
          addedToCart: {
            title1: "Regal zum Warenkorb",
            title2: "hinzugefügt",
            info: "Dein Regal wurde erfolgreich zum Warenkorb hinzu gefügt. Wir bieten passend hierzu auch Tische, Hocker und Bänke an. Diese lassen sich genauso komfortabel konfigurieren wie das Regal. Und bei mehreren Produkten gibt es auf alle günstigeren Möbestücke 10% Mengenrabatt.",
            close: "Schliessen",
            furtherProducts: "Weitere Produkte",
            furtherProductsMobile: "Produkte",
            toCart: "Zum Warenkorb",
            toCartMobile: "Warenkorb"
          },
          startConfigurator: "Konfigurator starten",
          backgroundInfo: "Mehr zu unseren Regalen",
          reviews: "Rezensionen"
        },
        infoTeaser: "Das rho 17 Regal - der Neuzugang in der rho-Familie. Wie bei allen unseren Produkten, hast du auch hier die Möglichkeit individuelle Anpassungen vorzunehmen und das Regal nach deinen eigenen Vorstellungen, passend für deinen Raum zu gestalten.",
        infoSizeTitle:"Größe:",
        infoSizeText: "Unser Musterregal ist 2m breit und 1,8m hoch. Das Gestell wurde mit einem matten Klarlack veredelt (Option: “Klar” im Konfigurator). Ob Bücherregal, für deine Pflanzen oder Deko, hier findet auf bis zu 10 Regalbrettern alles Platz, was dir lieb ist.  Überlege dir am besten, wie lang das gesamte Regal sein soll und wie viele Fächer du benötigst. Die Breite des Regals ist von 60cm bis 220cm einstellbar, die Höhe lässt sich bis 150cm m einstellen. Du hast außerdem die Möglichkeit ab einer Länge von 100cm eine mittlere Säule einzubauen, um mehr Stabilität zu erhalten. Und als wäre das nicht schon genug, kannst du dein Regal auch asymmetrisch gestalten und einzelne Regalbretter, und sogar die äußeren Säulen, kürzen.",
        infoPlanksTitle: "Die Gerüstbohlen:",
        infoPlanksText: "Unsere Regale bestehen aus alten Gerüstbohlen, die wir von unserem Partner aus Brandenburg abkaufen und aufarbeiten. Jede Bohle ist mit ihren Abnutzungsspuren, Löchern und Farbklecksen einzigartig und macht jedes Möbelstück zu einem Unikat. Du hast in unserem Konfigurator die Möglichkeit, jedes einzelne Brett für dein Regal auszuwählen.",
        infoFrameTitle: "Das Gestell:",
        infoFrameText: "Die Gestelle bestehen aus pulverbeschichtetem Stahl und sind verfügbar in verschiedenen Farben. Wähle aus dem Farbfächer deine Lieblingsfarbe aus und setze bunte Akzente in deinem Zuhause.",
        infoDeliveryTitle:"Lieferung:",
        infoDeliveryText:"Jedes Möbelstück wird individuell von Hand in unserer Werkstatt in Berlin gefertigt und ist spätestens 8 Wochen nach Auftragseingang bei dir. Die Lieferung erfolgt mit unserem Speditionspartner zu deinem Wunschtermin. Es ist außerdem möglich dein neues Regal persönlich in unserer Werkstatt abzuholen.",
        bulletpoints: ["Für jede Bestellung wird ein Baum gepflanzt",
                        "Upcycling ist nachhaltig",
                        "Jede Gerüstbohle ist individuell",
                        "10% Preisnachlass bei mehreren Produkten",
                        "Mit Liebe handgefertigt in Berlin",
                        "Gratis Versand bis in die Wohnung"],
                        // "noch vor Weihnachten bei dir"],
      },
      frameConfigurator: {
        configurator : {
          addedToCart: {
            title1: "Rahmen zum Warenkorb",
            title2: "hinzugefügt",
            info: "Dein Rahmen wurde erfolgreich zum Warenkorb hinzu gefügt. Wir bieten passend hierzu auch Tische, Hocker und Bänke an. Diese lassen sich genauso komfortabel konfigurieren wie der Rahmen. Und bei mehreren Produkten gibt es auf alle günstigeren Möbestücke 10% Mengenrabatt.",
            close: "Schliessen",
            furtherProducts: "Weitere Produkte",
            furtherProductsMobile: "Produkte",
            toCart: "Zum Warenkorb",
            toCartMobile: "Warenkorb"
          },
          startConfigurator: "Konfigurator starten",
          backgroundInfo: "Mehr zu unseren Rahmen",
          reviews: "Rezensionen"
        },
        infoTeaser: "Du bist noch auf der Suche nach einem passenden Deko-Objekt zu deinen neuen Möbeln?",
        infoGeneral: "Ab sofort kannst du dir ebenfalls wunderschöne Rahmen aus unseren Gerüstbohlen gestalten. Ob Whiteboard, Tafel, Spiegel oder Bilderrahmen  mit Passepartout - unsere neuen Holzrahmen sind vielfältig verwendbar und direkt über unseren Konfigurator plan- und bestellbar.",
        infoPlanksTitle: "Der Rahmen:",
        infoPlanksText1: "Unsere Holzbohlen haben mindestens 10 Jahre im Gerüstbau gedient und wurden aufgrund von Sicherheitsvorkehrungen aussortiert. Jedoch ist das Holz noch strapazierfähig genug, um daraus langlebige Möbel und Deko-Objekte zu bauen. ",
        infoPlanksText2: "Wir arbeiten die Holzbohlen alle einzeln auf und fertigen besondere Unikate daraus. Jedes Brett ist einzigartig und hat individuelle Gebrauchsspuren wie kleine Löcher, Risse oder Farbkleckse.",
        infoFillingTitle: "Was kommt in den Rahmen?",
        infoFillingText: "Bei der Gestaltung und Planung der Rahmen hast du die Möglichkeit deine Wunschmaße anzugeben. Jede Seite kann zwischen 20 cm bis 150 cm kurz bzw. lang sein. Wähle im nächsten Schritt, ob du ein Whiteboard, eine magnetische Tafel, einen Spiegel oder ein schwarzes Passepartout haben möchtest. Es besteht außerdem die Möglichkeit eine Glasscheibe einzusetzen, um deine Kunst oder Fotos noch besser in Szene zu setzen.",
        infoDeliveryTitle:"Lieferung:",
        infoDeliveryText:"Die Rahmen werden gut verpackt und geschützt per Post verschickt. Innerhalb von 8 Wochen ist dein Unikat bei dir.",
        disclaimerTitle:"Bitte beachte folgendes:",
        disclaimerText:"Wichtig, bitte lesen: Für die Holzrahmen verwenden wir Recyclingstücke unserer Gerüstbohlen, die bei der Herstellung unserer größeren Möbel anfallen. Die Optik der Bohlen bleibt erhalten. Wir wählen Holzstücke aus, die relativ eben und mittlere Gebrauchsspuren haben. Bitte beachte, dass dein Rahmen von unseren Fotos abweichen kann. Gerne kontaktiere uns für Sonderwünsche oder wenn du vorab einen Blick auf den Rahmen werfen möchtest.",
        bulletpoints: ["Für jede Bestellung wird ein Baum gepflanzt",
                        "Upcycling ist nachhaltig",
                        "Jede Gerüstbohle ist individuell",
                        "10% Preisnachlass bei mehreren Produkten",
                        "Mit Liebe handgefertigt in Berlin",
                        "Gratis Versand bis in die Wohnung"],
                        // "noch vor Weihnachten bei dir"],
      },
      benchConfigurator: {
        configurator : {
          size: {
            title: "Maße"
          },
          frame: {
            title: "Gestelltyp"
          },
          color: {
            title: "Gestellfarbe"
          },
          chooseWood: {
            title: "Gerüstbohlen",
            abovePlanks: "Jedes Brett wurde fotografiert, so kannst du genau auswählen welches für deine Bank eingesetzt werden soll.",
            abovePlanksTitle: "Wähle jede Gerüstbohle individuell"
          },
          addedToCart: {
            title1: "Bank zum Warenkorb",
            title2: "hinzugefügt",
            info: "Deine Bank wurde erfolgreich zum Warenkorb hinzu gefügt. Wir bieten passend hierzu auch Tische und Hocker an. Diese lassen sich genauso komfortabel konfigurieren wie die Bank. Und bei mehreren Produkten gibt es auf alle günstigeren Möbestücke 10% Mengenrabatt.",
            close: "Schliessen",
            furtherProducts: "Weitere Produkte",
            furtherProductsMobile: "Produkte",
            toCart: "Zum Warenkorb",
            toCartMobile: "Warenkorb"
          },
          startConfigurator: "Konfigurator starten",
          backgroundInfo: "Mehr zu unseren Bänken",
          reviews: "Rezensionen"
        },
        infoTeaser:"Unsere Bänke passen optisch nicht nur fantastisch zu den rho 17 Tischen, sondern lassen sich auch mit anderen Möbelstücken gut kombinieren. Und auch einzeln als Sitzgelegenheit im Flur machen sich die Gerüstbohlenbänke super.",
        infoGeneralText: "Bei der Gestaltung und Planung der Bänke hast du die Möglichkeit deine Lieblingsbohle auszuwählen und kannst das Gestell in verschiedenen Farben pulverbeschichten lassen. Die Länge ist von einem Meter bis 2,20 m individuell variabel.",
        infoPlanksTitle: "Die Gerüstbohlen:",
        infoPlanksText: "Unsere Bohlen haben mindestens 10 Jahre im Gerüstbau gedient und wurden aufgrund von Sicherheitsvorkehrungen aussortiert. Jedoch ist das Holz noch strapazierfähig genug, um daraus langlebige Möbel zubauen. Wir arbeiten die Holzbohlen alle einzeln auf, fotografieren sie und bauen anschließend dein rho 17 Unikat daraus. Jedes Brett ist einzigartig und hat Gebrauchsspuren wie kleine Löcher, Risse oder Farbkleckse.",
        infoDeliveryTitle:"Lieferung:",
        infoDeliveryText:"Jedes Möbelstück wird individuell von Hand in unserer Werkstatt in Berlin gefertigt und ist spätestens 8 Wochen nach Auftragseingang bei dir. Die Lieferung erfolgt mit unserem Speditionspartner zu deinem Wunschtermin. Es ist außerdem möglich deine Bank persönlich in unserer Werkstatt abzuholen.",
        bulletpoints: ["Für jede Bestellung wird ein Baum gepflanzt",
                        "Upcycling ist nachhaltig",
                        "Jede Gerüstbohle ist individuell",
                        "10% Preisnachlass bei mehreren Produkten",
                        "Mit Liebe handgefertigt in Berlin",
                        "Gratis Versand bis in die Wohnung"],
                        // "noch vor Weihnachten bei dir"],
      },
      stoolConfigurator: {
        configurator : {
          size: {
            title: "Maße"
          },
          frame: {
            title: "Gestelltyp"
          },
          color: {
            title: "Gestellfarbe"
          },
          chooseWood: {
            title: "Gerüstbohlen",
            abovePlanks: "Jedes Brett wurde fotografiert, so kannst du genau auswählen welches für deinen Hocker eingesetzt werden soll.",
            abovePlanksTitle: "Wähle jede Gerüstbohle individuell"
          },
          addedToCart: {
            title1: "Hocker zum Warenkorb",
            title2: "hinzugefügt",
            info: "Dein Hocker wurde erfolgreich zum Warenkorb hinzu gefügt. Wir bieten passend hierzu auch Tische und Bänke an. Diese lassen sich genauso komfortabel konfigurieren wie der Hocker. Und bei mehreren Produkten gibt es auf alle günstigeren Möbestücke 10% Mengenrabatt.",
            close: "Schliessen",
            furtherProducts: "Weitere Produkte",
            furtherProductsMobile: "Produkte",
            toCart: "Zum Warenkorb",
            toCartMobile: "Warenkorb"
          },
          startConfigurator: "Konfigurator starten",
          backgroundInfo: "Mehr zu unseren Hockern",
          reviews: "Rezensionen"
        },
        infoTeaser:"Unsere Hocker passen optisch nicht nur fantastisch zu den rho 17 Tischen, sondern lassen sich auch mit anderen Möbelstücken gut kombinieren. Und auch einzeln als Sitzgelegenheit im Flur machen sich die Hocker super.",
        infoGeneralText: "Bei der Gestaltung und Planung der Hocker hast du die Möglichkeit deine Lieblingsbohle auszuwählen und kannst das Gestell in verschiedenen Farben pulverbeschichten lassen.",
        infoPlanksTitle: "Die Gerüstbohlen:",
        infoPlanksText: "Unsere Bohlen haben mindestens 10 Jahre im Gerüstbau gedient und wurden aufgrund von Sicherheitsvorkehrungen aussortiert. Jedoch ist das Holz noch strapazierfähig genug, um daraus langlebige Möbel zubauen. Wir arbeiten die Holzbohlen alle einzeln auf, fotografieren sie und bauen anschließend dein rho 17 Unikat daraus. Jedes Brett ist einzigartig und hat Gebrauchsspuren wie kleine Löcher, Risse oder Farbkleckse.",
        infoDeliveryTitle:"Lieferung:",
        infoDeliveryText:"Jedes Möbelstück wird individuell von Hand in unserer Werkstatt in Berlin gefertigt und ist spätestens 8 Wochen nach Auftragseingang bei dir. Die Lieferung erfolgt mit unserem Speditionspartner zu deinem Wunschtermin. Es ist außerdem möglich deinen Hocker persönlich in unserer Werkstatt abzuholen.",

        bulletpoints: ["Für jede Bestellung wird ein Baum gepflanzt",
                        "Upcycling ist nachhaltig",
                        "Jede Gerüstbohle ist individuell",
                        "10% Preisnachlass bei mehreren Produkten",
                        "Mit Liebe handgefertigt in Berlin",
                        "Gratis Versand bis in die Wohnung"],
                        // "noch vor Weihnachten bei dir"],
      },
      cart: {
        orderSuccess: "Vielen Dank, dein Einkauf war erfolgreich. Wir melden uns in kürze bei dir per E-Mail. Falls du noch weitere Fragen hast, kontaktiere uns gerne.",
        originTitle: "Bitte verrate uns doch, wie du von uns erfahren hast:",
        originFacebook: "Facebook",
        originInstagram: "Instagram",
        originGoogle: "Suchmaschine",
        originFriends: "Bekanntenkreis",
        originOther: "Andere Quelle",
        originSubmit: "Fertig",
        orderFailure: "Leider hat etwas mit der Zahlung nicht funktioniert. Kontaktiere uns gerne, oder versuche es noch einmal.",
        productLink: "Zu den Produkten",
        checkoutNow1: "Jetzt für ",
        checkoutNow2: "€ bestellen",
        checkoutWidthShipping: "Der Preis ist inkl. Versand, Paypal Käuferschutz und MwSt.",
        checkoutWidthoutShipping: "Der Preis ist inkl. Paypal Käuferschutz und MwSt.",
        noProductsInCart: "Du hast noch keine Produkte im Warenkorb",
        productList: {
          yourCart: "Dein Warenkorb",
          dimensions: "L x B x H: ",
          dimensionsShelf: "B x H x T: ",
          frame: "Gestell: ",
          color: "Farbe: ",
          colorShelf: "Gestellfarbe: ",
          shelfNumberPillars: "Anzahl Säulen: ",
          shelfNumberBoards: "Anzahl Regalböden: ",
          price: "Preis: ",
          originalPrice: "Originalpreis: ",
          discount: "Mengenrabatt: ",
          discountPrice: "Dein Preis: "
        },
        contactForm: {
          firstName: "Vorname",
          lastName: "Nachname",
          mail: "E-Mail",
          country: "Land",
          shipping: "Gratis per Spedition versenden (Ankunft binnen 8 Wochen)",
          shippingText: "Deutschlandweit gratis Lieferung bis ins Wohnzimmer. In nur 8 Wochen.",
          outsideGermany: "Lieferung ausserhalb von Deutschland",
          expressBuildNo: "Gratis Lieferung innerhalb von 8 Wochen",
          // expressBuildYes: "Express Lieferung in 6 Wochen (+65€)",
          pickUp: "Selbst bei Berlin abholen (-€",
          outsideGermanyText: 'Fülle alle Daten aus und klicke den Button "Reservieren". Wir erstellen dir dann ein individuelles Angebot inkl. Lieferung.',
          pickUpAdress1: "Abholen kannst du deine Bestellung in der",
          pickUpAdress2: "Fernstr. 27",
          pickUpAdress3: "15741 Bestensee",
          streetAndNumber: "Straße und Hausnummer",
          zip: "PLZ",
          city: "Stadt",
          phone: "Telefonnummer",
          voucher: "Gutschein",
          applyVoucher: "Einlösen",
          voucherSubtracted1: "Es wurden ",
          voucherSubtracted2: "€ gutgeschrieben",
          discountSubtracted1: "Es wurden ",
          discountSubtracted2: "€ Mengenrabatt abgezogen",
          message: "Möchtest du noch etwas mitteilen?",
          datasecurity: "Ich habe die Datenschutzerklärung gelesen und erkläre mich damit einverstanden, dass meine Daten in deren Rahmen verwendet werden."
        },
        buyViaTransfer: "Kauf per Überweisung abschliessen",
        payStripe: "Weitere Zahlungsmittel",
        reserve: "Reservieren",
        orderReserved: "Deine Bestellung wurde erfolgreich reserviert. Wir melden uns bald mit einem Angebot bei dir."
      },
      faq: {
        title: "Faq",
        text: "Wir versuchen, die Website so informativ wie möglich zu halten. Manchmal möchtest du aber vielleicht etwas detailreichere Antworten. Deshalb findest du hier eine Zusammenfassung der häufigsten Fragen detailliert beantwortet.",
        planks: {
          title: "Fragen zu den Gerüstbohlen",
          text: "Über 10 Jahre alte Unikate",
          info: [
            {
              title: "Woher kommen die Bohlen?",
              text: "Wir beziehen die Gerüstbohlen von einem lokalen Händler aus Berlin. Er kauft die gebrauchten Bohlen Lkw-weise und verkauft sie dann weiter, - üblicherweise an Bauunternehmen. Die ein- oder andere Bohle findet aber den Weg zu uns, und vielleicht ja auch in dein Wohnzimmer."
            },
            {
              title: "Wie werden sie bearbeitet?",
              text: "Wir schleifen die Bohlen zuerst grob ab, um die oberste, staubige Schicht zu entfernen. Anschließend folgt ein Feinschliff, größere Risse und Löcher werden aufgefüllt und dann wird die Gerüstbohle mit einer ersten Schicht Öl behandelt. Ist diese getrocknet, machen wir ein Bild und stellen sie zur Auswahl auf die Website. Nach deiner Bestellung wird die Bohle ein zweites Mal fein geschliffen und zu guter letzt mit unserem eigens entwickeltem Möbelwachs behandelt. Fertig ist die Bohle für dein Möbelstück."
            },
            {
              title: "Womit werden sie behandelt?",
              text: "Wir behandeln die Bohlen mit unserem eigens entwickeltem Möbelwachs aus reinem Leinöl und Bienenwachs. Mehr informationen hierzu findest du unter 'Bienen'. Falls du nach einiger Zeit die Oberflächenbehandlung etwas auffrischen möchtest, kontaktiere uns gerne und wir lassen dir etwas zukommen. Alternativ kannst du auch reguläres Möbelwachs vom Baumarkt verwenden."
            },
            {
              title: "Welches Holz ist es?",
              text: "Gerüstbohlen sind aus Fichtenholz. Durch die vielen Jahre im Einsatz und die zahlreichen damit verbundenen Stunden, die sie der Witterung ausgesetzt sind, erhalten sie eine dunklere, kontrastreiche Farbgebung."
            },
            {
              title: "Kann ich ein Probestück haben?",
              text: "Wenn du dir unsicher bist, kannst gerne ein Probestück einer Gerüstbohle haben. Frag uns einfach direkt an."
            }
          ]
        },
        frames: {
          title: "Fragen zu den Gestellen",
          text: "Individuell hergestellt von unserem Partnerbetrieb",
          info: [
            {
              title: "Aus welchem Material ist das Gestell?",
              text: "Das Gestell ist aus Stahl und wird verschweißt. Wir lassen unsere Gestelle von einem professionellen Schlosserbetrieb individuell auf Maß anfertigen."
            },
            {
              title: "Wie ist die Oberflächenbehandlung?",
              text: "Die Gestelle werden hochwertig lackiert. Das sogenannte Pulverbeschichtungs-Verfahren ermöglicht eine homogene und widerstandsfähige Oberfläche, da die Farbe bei hoher Temperatur in das Metall “eingebacken” wird."
            },
            {
              title: "Was ist mit unebene Böden?",
              text: "Wir kennen und lieben die schönen altbau Böden. Leider sind sie manchmal etwas uneben und daher ist uns sofort aufgefallen, dass wir die Füße justierbar machen müssen. Der Fuß besteht aus einem Kunststoffgleiter, wovon sich jeder etwa 2 cm in der Höhe einstellen lässt."
            }
          ]
        },
        configurator: {
          title: "Fragen zu dem Konfigurator",
          text: "So viel Gestaltungsspielraum wie möglich.",
          info: [
            {
              title: "Gibt es weitere Größen?",
              text: "Ja natürlich. Der Konfigurator lässt zwar nur bestimmte Größen zu, aber wir fertigen auch andere Dimensionen auf Wunsch an. Bitte bedenke, dass die vorhandenen Gerüstbohlen nur eine Länge von bis zu 2,2 m zulassen. Falls du einen längeren Tisch haben möchtest: Schreib uns einfach und wir lassen dir Bilder von längeren Bohlen zukommen."
            },
            {
              title: "Kann ich nur Bohlen bekommen?",
              text: "Vielleicht hast du ja schon ein Gestell, das du gerne magst, und es wäre ja schade, dies wegzuschmeißen. Deshalb verkaufen wir die Bohlen auch einzeln für 200 Euro pro Stück inkl. Versand. Sie werden auf dein Wunschmaß geschnitten, geschliffen und geölt Bitte trete hierfür direkt mit uns in Kontakt."
            },
            {
              title: "Gibt es auch andere Formen?",
              text: "Wir möchten deiner Kreativität keine Grenzen setzen. Bitte sende uns dein gewünschtes Design zu (als Skizze oder ein Bild das Dich inspiriert hat) und wir machen dir ein individuelles Angebot."
            },
            {
              title: "Ist ein anderes Gestell möglich?",
              text: "Wie bei Farbe und Form des Tisches möchten wir dich auch hier nicht einschränken. Beschreibe uns gerne in einer individuellen Anfrage (per Telefon, Whatsapp oder E-Mail), wie du dir dein Wunschgestell vorstellt, und wir kümmern uns um alles Weitere."
            }
          ]
        },
        shipment: {
          title: "Fragen zur Bezahlung & Versand",
          text: "Es soll alles so einfach wie möglich sein.",
          info: [
            {
              title: "Ist der Versand versichert?",
              text: "Wir haben schon viele Möbel an unsere Spedition gegeben und es gab bisher noch keinen nennenswerten Schaden. Falls aber doch etwas passieren sollte, haften wir natürlich für entstandene Schäden."
            },
            {
              title: "Wie kommen die Möbel an?",
              text: "Wir verschicken alle Moebelstücke mit einer zuverlässigen Spedition. Sobald die Fertigstellung absehbar ist, kontaktieren wir dich, um ein genaues Ankunftsdatum auszumachen."
            },
            {
              title: "Wann kommt der tisch an?",
              text: "Da wir alle Möbel individuell herstellen und auch die Gestelle vom Schlosser einzeln produzieren lassen, haben wir eine Lieferzeit von 8 Wochen. Unser Speditionspartner liefert je nach Anforderung auch am Wochenende oder Abends. Wir möchten, dass deine Bestellung so unkompliziert wie möglich ankommt, deshalb übernehmen wir gerne etwaige Mehrkosten für dich."
            },
            {
              title: "Lieferung bis in die Wohnung?",
              text: "Ja. Die Möbel liefern wir innerhalb Deutschlands gerne bis in die Wohnung."
            },
            {
              title: "Ist eine Abholung möglich?",
              text: "Du bist in Berlin oder hast Lust auf einen kleinen Besuch in die Hauptstadt? Komme gerne bei uns in der Werkstatt vorbei und hole Deinen Tisch persönlich ab. Da wir uns dann die Spedition sparen, kommt das Ganze für dich natürlich auch günstiger. Klicke hierfür einfach im Warenkorb auf den Button zum selbst abholen. Wir freuen uns immer, wenn wir Besuch bekommen. Gerne kannst du auch so vorbeischauen und gucken, wie dein Tisch vorankommt. Oder möchtest du die Gerüstbohlen zur Auswahl in echt sehen? Komme auch hierfür gerne in unserer Werkstatt vorbei."
            },
            {
              title: "Liefert ihr auch ausserhalb von Deutschland?",
              text: 'Ja, allerdings müssen wir hierfür ein individuelles Angebot von der Spedition einholen. Konfiguriere einfach deine Möbel, gebe beim Checkout deine Adresse ein und ggf. noch eine Nachricht. Setze dann das Häkchen bei "Lieferung ausserhalb von Deutschland" und schliesse den Vorgang ab mit dem Button "reservieren". Wir melden uns dann bei dir mit einem individuellen Angebot inkl. Lieferung.'
            }
          ]
        },
        other: {
          title: "Weitere Fragen",
          text: "Ein solch besonderes Möbelstück will gut überlegt sein.",
          info: [
            {
              title: "Gibt es Rabatt bei größeren Bestellungen?",
              text: "Na klar! Für jede Bestellung von mehr als einem Möbelstück gibt es 10% auf alle weiteren, günstigeren Artikel."
            },
            {
              title: "Was wenn ich mit dem Möbestück unzufrieden bin?",
              text: "Uns liegt nichts mehr am Herzen als zufriedene Kunden. Nicht nur weil wir selbst an unsere Produkte glauben, auch rein wirtschaftlich freuen wir uns über Empfehlungen von dir an deinen Freundeskreis. Leider sind die Tische alle Unikate und daher ist eine Rücknahme nicht so einfach möglich. Da wir jede einzelne Gerüstbohle für die Tische und Bänke fotografieren und zur Konfiguration zur Verfügung stellen, versuchen wir so gut es geht, bösen Überraschungen aus dem Weg zu gehen. Falls aber doch etwas nicht passen sollte, zögere bitte nicht, dich mit uns in Verbindung zu setzen, und wir werden dann gemeinsam eine Lösung finden, die am Ende alle zufrieden stellt."
            }
          ]
        },
        additionalIdeas: "Hast du noch weitere Fragen? Kontaktiere uns gerne:",
        phone: "Telefon",
        mail: "E-Mail"
      },
      about: {
        title: "Möbelunikate nach Deinem Wunsch",
        subtitle: "Unsere Vision ist es, Deinen Lebensraum mit individuellen und nachhaltigen Konzepten zu bereichern.",
        history: {
          title: "Jedes Produkt ist einzigartig - Dein rho 17 Unikat",
          text: "Unsere Möbel sind zeitlos modern und werden immer auf Kundenwunsch angefertigt. Wir kalkulieren fair. Unsere Möbelstücke bewegen sich auf absolut handwerklichen Spitzenniveau und werden in unserer Berliner Werkstatt für dich hergestellt. Alle unsere Produkte werden von dir konfiguriert und sind somit Einzelstücke. "
        },
        julian: {
          title: "Das ist rho 17 - Coding meets Handwerk",
          text1: "So viel sei gesagt: Unser Gründer Julian hat viele Talente. Seine Leidenschaft ist aber schon seit je her das Möbel designen und die handwerkliche Umsetzung seiner Produktideen. Schon als Kind fand man Julian im Garten mit Akkuschrauber und Stichsäge beim Bau doppelstöckiger Baumhäuser (wirklich!) und unterstützte seine Eltern bei der Renovierung eines kompletten Hauses, das er bereits in jungen Jahren mit eigenen Möbeln ausstatte. Mit seinem ersten Computer begann er gleichzeitig das Zeichnen und Entwerfen von Produkten in 3D-Programmen, mit anschließender Umsetzung dieser Projekte. Während des Maschinenbau-Studiums, begann Julian seine technischen Fähigkeiten zu jeglichen materiellen Stoffen mit seinen Designideen und handwerklichem Geschick zu verbinden und gründete mit Kommilitonen rho 17. Neben Möbelstücken, realisierte das Team bereits den Ausbau mehrerer Cafés, entwickelte individuelle Einrichtungskonzepte und wirkte beim Festival Monticule mit.",
          text2: "Nach einem zweiten Studium im Bereich Software-Entwicklung und IT entwickelte Julian die erste online Version von rho 17 - in Form eines Tisch-Konfigurators, der Julians Hobby und Leidenschaft perfekt vereint. ",
          text3: "Und jetzt sind wir mittlerweile hier angekommen… mit einem größeren Team, eigener Werkstatt, mehr Produkten. And there is more to come ;)",
        },
        team: {
          title: "Das Team",
          text1: "rho 17 ist aus einem Kollektiv entstanden und trägt den Gedanken von gemeinsam etwas schaffen immer noch weiter in sich. Wir arbeiten alle mit viel Liebe daran, nachhaltige Möbel zu produzieren und versuchen dabei unsere Arbeitsprozesse und auch die Möbel selbst immer wieder zu hinterfragen und neu zu gestalten.",
          text2: "Gemeinsam möchten wir nachhaltige, langlebige Möbel erschaffen, bei denen Individualität und die Anforderungen unserer Kunden im Vordergrund stehen. Jedes rho 17 Produkt ist einzigartig und wird von Hand für dich hergestellt.",
          julianTitle: "Julian",
          julianText: "Gründer",
          wingTitle: "Wing",
          wingText: "Produktions Experte",
          friederTitle: "Frieder",
          friederText: "Bienenflüsterer",
          elliTitle: "Elli",
          elliText: "Art Direktorin",
          justusTitle: "Justus",
          justusText: "Schleifkönig",
        },
        furtherQuestions: "Hast du noch weitere Fragen? Kotaktiere uns gerne:",
        phone: "Telefon",
        mail: "E-Mail"
      },
      sustainability: {
        title: "We care!",
        subTitle1: "Aus Liebe zu unserer Umwelt haben wir uns für das Upcycling alter Gerüstbohlen entschieden.",
        subTitle2: "Jedes rho 17 Möbelstück ist nicht nur eine Investition in dein Zuhause, sondern auch in die Zukunft unseres Planeten, denn:",
        subTitle3: "Wir pflanzen Bäume.",
        longLasting1: "Unsere Möbelstücke sind langlebig und überdauern Trends. Die Qualität lässt eine jahrelange Nutzung zu und das zeitlose Design lässt sich hervorragend zu verschiedenen Wohnstilen kombinieren.",
        longLasting2: "Und nicht nur das, je länger du deinen Tisch benutzt, desto schöner und charmanter wird er.",
        planksCounter: "recycelte Gerüstbohlen im letzten Monat",
        planksTitle: "Unsere Gerüstbohlen",
        planksText1: "Unsere Holzbohlen erzählen eine Geschichte. Sie sind nicht perfekt, sie haben Löcher, sie haben Abnutzungsspuren, aber gerade das macht sie so einzigartig schön. Wir haben uns für diesen Werkstoff entscheiden, da wir die raue, industrielle Optik des Holzes lieben - und natürlich, aus Gründen der Nachhaltigkeit. Die Bretter sind immer noch so robust, dass sie sich hervorragend weiterverarbeiten und in einzigartige Möbelstücke umfunktionieren lassen.",
        planksText2: "Nach circa 15 Jahren im Einsatz, müssen die Bohlen aussortiert und ersetzt werden, wenn sie die hohen Anforderungen für den Gerüstbau nicht mehr erfüllen können. Nach ihrem langen Arbeitsleben suchen wir die Holzbretter persönlich aus und schätzen dabei gerade die individuellen Einkerbungen und Gebrauchsspuren. Sie bestehen aus verschiedenen robusten Nadelhölzern, meist Kiefer oder Fichte, und werden in unserer Werkstatt aufgearbeitet und für ihren neuen Einsatz vorbereitet.",
        planksText3: "Durch die Nutzung des schon vorhandenen Materials schonen wir Ressourcen und schaffen gleichzeitig etwas Neues - individuelle Möbelstücke in liebevoller Handarbeit für dich gefertigt.",
        treesCounter: "gepflanzte Bäume im letzten Monat",
        treesText1: "Natürlich wissen wir, dass auch für unsere Bohlen irgendwann einmal ein Baum gefällt wurde. Daher möchten wir unserer Natur etwas zurückgeben. Mit jedem gefertigten Möbelstück unterstützen wir das Klimaschutzprojekt Plant-My-Tree und pflanzen einen neuen Baum. Wir haben gezielt ein Aufforstungsprojekt in Deutschland gewählt und freuen uns darüber, neue Bäume im Heideland Drössig, bei Finsterwalde, zu pflanzen.",
        treesText2: "Wir sind im engen Austausch mit der Organisation und werden demnächst die Aufforstungsfläche besuchen und uns den Prozess vor Ort anschauen.",
        treesText3: "Beim Kauf eines rho 17 Unikats stellen wir eine Urkunde über die Baumpflanzung aus.",
        otherCounter1: "rho 17 läuft mit",
        otherCounter2: "kWh erneuerbarer Energie",
        otherText1: "Doch da hört der Klimaschutz bei uns noch nicht auf: Unsere Werkstatt läuft mit Ökostrom und wir sitzen derzeit sogar an der Planung einer eigenen Photovoltaikanlage. Auch unser Verpackungsmaterial wird fortlaufend optimiert und basiert immer mehr auf recycelten Materialien. Wir versuchen in all unseren Arbeitsprozessen so wenig Material wie nur möglich wegzuschmeißen. Klar, von Zeit zu Zeit fallen schon einige Reststücke an. Aus denen bauen wir dann zum Beispiel kleine Regale, Schlüsselbretter oder Schuhbänke für Familie und Freunde. Wann immer möglich, versuchen wir Auslieferungen zu bündeln, um auch hier unseren CO2 Fußabdruck gering zu halten. ",
        otherText2: "Zur Behandlung unserer Möbel verwenden wir unser eigenes in house hergestelltes Bienenwachsöl, das in enger Zusammenarbeit mit einem befreundeten Imker entstanden ist. Es wird auf der Basis von nachwachsenden Rohstoffen hergestellt und ohne Maschinen angerührt. Bienen sind unverzichtbar für funktionierende Ökosysteme. Diese Ökosysteme und die in diesen Lebensräumen vorkommenden Organismen sorgen u. a. für Sauerstoff, sauberes Wasser, regulieren das Klima und liefern Nahrungs- und Heilmittel. Darum pflanzen wir nicht nur bienenfreundliche Blumen im Vorgarten unserer Werkstatt, sondern haben einen eigenen Imker mit im Team. ",
        furtherIdeas: "Noch eine Idee was wir verbessern können?",
        beesLink: "Mehr über unsere Bienen",
        submitFurtherIdeas: "Vorschlag absenden",
        furtherIdeasLabel: "deine nachricht an uns"
      },
      bees: {
        title: "rho Bienen",
        subTitle1: "Entdecke unser hauseigenes Möbelwachs.",
        subTitle2: "Hochwertig, ökologisch und regional -",
        subTitle3: "außerdem gibt's noch leckeren Honig.",
        introTitle: "Das rho 17 Möbelwachs",
        intro1: "Nachhaltigkeit und Bienen gehören irgendwie zusammen. Aber Tische und Bienen? rho 17 und Bienen?",
        intro2: "Ja, ab sofort schon und wir sind ziemlich stolz darauf.",
        waxText1: "Unsere neue Oberflächenbehandlung für unsere Möbelstücke wir jetzt inhouse hergestellt und besteht einzig und allein aus Bienenwachs und Leinöl. That’s it!",
        waxText2: "Zusammen mit unserem Freund, Bienen-Spezialisten und Imker Frieder haben wir ein Möbelwachs entwickelt, das unseren hohen Ansprüchen genügt und die Tische, Bänke und Hocker ökologisch versiegelt, imprägniert und schützt.",
        waxBulletsTitle: "Unser Möbelwachs ist:",
        waxBullets: ["lebensmittelecht", "geruchsarm", "100% natürlich", "lösemittelfrei", "leicht zu verarbeiten", "auf Basis nachwachsender Rohstoffe"],
        waxText3: "Das Bienenwachsöl wird in unserer Werkstatt mit viel Liebe, Arbeit und Erfahrung hergestellt.",
        friederTitle:"Über Frieder & seine Bienen:",
        friederText1:"Wir sind froh, Frieder mit seinem Tatendrang und seiner Bienen-Expertise im Team zu haben. Frieder’s Bienenstand befindet sich am Rande Berlins in einem liebevoll gestalteten Gemüse- und Obstgarten. In der dörflichen Umgebung gibt es Linden und Kastanienalleen, Robinienhaine, die charakteristischen brandenburgischen Kiefernwälder, etwas Landwirtschaft und wilde Wiesen.",
        friederText2:"Frieder beschäftigt sich leidenschaftlich seit seiner Jugend mit der Bienenhaltung und den damit verbundenen ökologischen und gesellschaftlichen Zusammenhängen. Er imkert mit einer kleinen Anzahl von derzeit 10 Stöcken in Anlehnung an die Bioland-Richtlinien.",
        friederText3:"Neben den Rohprodukten von Frieders Bienen verwenden wir außerdem bei Engpässen Bienenwachs von ausgewählten Imker:innen aus der Region.",
        honeyTitle:"Bienenhonig",
        honeyText:"Als kleine Besonderheit erhalten unsere Kund:innen ab jetzt zu jeder Bestellung ein Glas von Frieder’s leckerem Honig.",
        honeyBullets:["Fruchtig-herb", "Cremig", "Sommerernte"],
        furtherQuestions: "Hast du noch Fragen? Kotaktiere uns gerne:",
        phone: "Telefon",
        mail: "E-Mail"
      },
      main: {
        intro: {
          title1: "Möbelunikate",
          title2: "aus Gerüstbohlen",
          subTitle1: "rho 17 verbindet hochwertiges Design mit Nachhaltigkeit.",
          subTitle2: "Wir bauen langlebige Möbelstücke im industrial Style - ",
          subTitle3: "individuell angefertigt nach deinen Vorstellungen.",
          link: "Jetzt konfigurieren",
          delivery: "Lieferung ab 6 Wochen"
        },
        material: {
          title: "recycelte Gerüstbohlen im vergangenen Monat",
          text1: "Upcycling = Nachhaltigkeit. Wir schonen Ressourcen und benutzen kein neues Holz für unsere Möbel, sondern schenken ausgedienten Holzbohlen aus dem Gerüstbau ein neues Leben. ",
          text2: "Wir arbeiten das Material auf - die Patina der Holzes, kleine Risse oder Farbkleckse, die über die Jahre entstanden sind, bleiben erhalten, sodass jede Bohle einen einzigartigen Look hat."
        },
        sustainability: {
          title: "neue Bäume im vergangenen Monat",
          text1: "We care! Mit jedem verkauften Möbelstück unterstützen wir das Klimaschutzprojekt",
          text2: "Plant-My-Tree und lassen einen neuen Baum in der Niederlausitzer Heidelandschaft pflanzen.",
          link: "Mehr über das Projekt"
        },
        design: {
          title: "Minimalistisches Industrial Design",
          text1: "Unsere Möbelstücke sind langlebig und überdauern Trends.",
          text2: "Die Qualität lässt eine jahrelange Nutzung zu und das zeitlose Design lässt sich hervorragend zu verschiedenen Wohnstilen kombinieren."
        },
        about: {
          title: "rho 17 - Coding meets Handwerk",
          text: "Wir möchten deinen Lebensraum mit individuellen und nachhaltigen Möbelkonzepten bereichern. Mit unserem Konfigurator kannst du deinen Tisch und eine neue Sitzgelegenheit nach eigenen Wunschmaßen planen und dabei sogar jede einzelne Gerüstbohle selbst aussuchen. In unserer Werkstatt in Berlin wird jedes Möbelstück von Hand und mit viel Liebe angefertigt und ist innerhalb von 8 Wochen bei dir zu Hause.",
          link: "Erfahre mehr über uns"
        },
        // furnitureConfigurator: {
        //   title: "Der Konfigurator für deine Möbel",
        //   text: [
        //     "Unsere nachhaltigen Möbelstücke werden immer individuell nach deinen Wunschmaßen angefertigt.",
        //     "Ob Schreibtisch oder Esstisch, ob Bank, Hocker oder Regal - deine Wunschmaße bestimmen die Größe der Möbel. Du kannst alles individuell gestalten: von den Maßen, über die Gestellform und -farbe, bis hin zu jeder einzelnen verwendeten Gerüstbohle - du entscheidest.",
        //     "Die Hauptrolle bei unseren Möbeln spielen ausgediente Holzbohlen aus dem Gerüstbau, die wir mit viel Liebe in unserer Werkstatt in Berlin von Hand aufarbeiten. Jede Bohle erzählt mit ihren Unperfektheiten eine eigene Geschichte und macht unsere Möbel einzigartig.",
        //     "Die Gestelle für unsere Möbel bestehen aus pulverbeschichtetem Stahl und sind erhältlich in verschiedenen Designs. Weiß findest du zu langweilig? Kein Problem. Wähle einfach deine Lieblingsfarbe aus.",
        //     "Konfiguriere jetzt dein rho 17 Unikat. Los geht’s!"
        //   ],
        //   link: "Jetzt konfigurieren!"
        // },
        furnitureConfigurator: {
          title: "Individuelle Möbel aus Gerüstbohlen",
          text: [
            "Unsere Möbel werden immer individuell nach deinen Wunschmaßen angefertigt.",
            "Ob Schreibtisch oder Esstisch, ob Bank, Hocker oder Regal - deine Wunschmaße bestimmen die Größe der Möbel. Du kannst mit unserem Konfigurator alles selber gestalten: von den Maßen, über die Gestellform und -farbe, bis hin zu jeder einzelnen verwendeten Gerüstbohle - you’re the boss.",
            "Konfiguriere jetzt dein neues rho 17 Unikat."
          ],
          link: "Los geht's"
        },
        // tableConfigurator: {
        //   title: "Der Konfigurator für deinen neuen Tisch",
        //   text: [
        //     "Unsere Möbel werden immer individuell angefertigt.",
        //     "Ob Schreibtisch oder Esstisch, ob Großfamilie oder Singlehaushalt - deine Wunschmaße bestimmen die Größe des Tisches.",
        //     "Die Gestelle für unsere Tische bestehen aus pulverbeschichtetem Stahl und sind erhältlich in verschiedenen Designs.",
        //     "Weiß findest du zu langweilig? Kein Problem. Wähle einfach deine Lieblingsfarbe aus.",
        //     "Alle Möbel werden mit viel Liebe in unserer Berliner Werkstatt von Hand gefertigt."
        //   ],
        //   link: "Jetzt konfigurieren!"
        // },
        tableConfigurator: {
          title: "Plane deinen neuen Tisch!",
          text: [
            "Ob Großfamilie oder Single-Haushalt; ob Couchtisch oder die langersehnte Dinnertafel für alle deine Freunde: Unsere Tische werden immer individuell nach deinen Vorstellungen und Wünschen angefertigt.",
            "Neben den Maßen kannst du jede einzelne Bohle auswählen, die wir dann final aufbereiten und mit dem Gestell zusammenbringen.",
            "Die Gestelle werden bei einem professionellen Schlosserbetrieb auf Maß bestellt und sind in verschiedenen Designs und Farben erhältlich. Weiß findest du zu langweilig? Kein Problem. Wähle einfach deine Lieblingsfarbe aus.",
            "Alle Möbel werden mit viel Liebe in unserer Werkstatt am Rande Berlins von Hand gefertigt."
          ],
          link: "Jetzt konfigurieren"
        },
        sittingConfigurator: {
          title: "Take a seat - Die rho 17 Sitzgelegenheiten",
          text: [
            "Passend zu unseren Tischen bieten wir auch Bänke & Hocker aus unseren Gerüstbohlen an.",
            "Auch bei der rho 17 Bank bestimmst du, wie viel Leute darauf Platz finden. Von einem Meter bis 2,20 m ist alles möglich.",
            "Setze bunte Akzente in deiner Küche oder Esszimmer mit unseren farbigen Gestellen.",
            "Natürlich hast du auch hier die Möglichkeit deine Wunsch-Gerüstbohle auszuwählen.",
            "Alles in 8 Wochen bei dir. Lieferung ins Wohnzimmer inklusive."
          ],
          link: "Jetzt konfigurieren!"
        },
        instagram: "Besuche uns auf Instagram",
        footer: {
          title: "Hast du noch weitere Fragen? Kontaktiere uns gerne:",
          phone: "Telefon",
          mail: "E-Mail"
        }
      },
      reviews: {
        table: {
          45: {
            //Gina ***
            text: "Die Lieferung des Tisches hat super geklappt und er gefällt uns richtig gut. Danke für Eure Arbeit!",
            date: "März 2024"
          },
          44: {
            //Gina ***
            text: "Mich haben schon die Produktbilder überzeugt.",
            date: "Dezember 2023"
          },
          43: {
            //Alexander ***
            text: "Ich fand das Gesamtkonzept mit der Nachhaltigkeit und der eigenen Auswahl der Bohlen super.",
            date: "Dezember 2023"
          },
          42: {
            //Konstantin ***
            text: "Alles toll, weiter so!",
            date: "September 2023"
          },
          41: {
            //Kathrin ***
            text: "Ich hatte ein Bild von den Tischen auf Social Media gesehen und mich direkt verliebt. Da musste ich nicht mehr lange überlegen und habe direkt bestellt.",
            date: "August 2023"
          },
          40: {
            //Felix ***
            text: "Mir gefiel die Aufmachung der Website und die Konfiguration eines individuellen Möbelstücks. Darum habe ich rho17 anderen bevorzugt.",
            date: "August 2023"
          },
          39: {
            //Marie-Sophie ***
            text: "Ich war sehr schnell begeistert von dem schönen Aussehen der Tische, und dass niemand anderes genau so einen Tisch haben wird, da die Bohlen Unikate sind",
            date: "August 2023"
          },
          38: {
            //Matthias 220 x 110 x 75
            text: "Dankeschön!",
            date: "August 2023"
          },
          37: {
            //Christina
            text: "Wir haben verschiedene Anbieter angeschaut und uns für Rho17 entschieden , weil Bekannte einen tollen Tisch von Euch hatten und gesagt haben, dass alles super lief.",
            date: "Juli 2023"
          },
          36: {
            //Thorben 220 x 110 x 75
            text: "Wir sind immer noch begeistert! :)",
            date: "Juni 2023"
          },
          35: {
            //Sophia
            text: "Ich wollte gerne ein nachhaltiges StartUp unterstützen und fand die Beispielbilder von realen Kunden eine tolle Referenz.",
            date: "Mai 2023"
          },
          34: {
            //Bernd
            text: "Letztendlich haben wir uns für rho 17 aufgrund des Konfigurators auf der Website und dem Rundumsorglos Service entschieden.",
            date: "April 2023"
          },
          33: {
            //Kerstin
            text: "Alles perfekt. Wir lieben unseren Tisch.",
            date: "April 2023"
          },
          32: {
            //Lena 160 x 90 x 75
            text: "Wir sind so verliebt in unseren Tisch 😍",
            date: "März 2023"
          },
          31: {
            //sven
            text: "Bestes Design und die Möglichkeit zur Individualisierung",
            date: "Februar 2023"
          },
          30: {
            //Hanna 160 80 75
            text: "Bin immer noch total begeistert 😊",
            date: "Februar 2023"
          },
          29: {
            //anja
            text: "die Möbel sind wohl behalten am Samstag hier angekommen. Sie sehen mega aus, alle sind begeistert!!!",
            date: "Februar 2023"
          },
          28: {
            //thomas
            text: "Ich hatte einen ähnlichen Tisch aus Gerüstbohlen aus Frankreich gesehen. Habe mich aber für rho17 entschieden, weil ich eine lokale Firma aus meiner Stadt einem ausländischen Onlineversand vorgezogen habe.",
            date: "Januar 2023"
          },
          27: {
            //claudia 220 100 75
            text: "Mein Tisch ist letzten Samstag mit der Spedition gut angekommen. Er sieht einfach klasse aus. Wir freuen uns sehr.",
            date: "Januar 2023"
          },
          26: {
            text: "ich bin super happy mit dem Tisch, er passt perfekt in unser Esszimmer und ist wirklich toll! Hut ab vor deiner/eurer Arbeit! Die Lieferung war ohne Probleme, die Jungs waren pünktlich hier und haben den doch schweren Tisch hier hoch getragen. Danke noch einmal, auch für deine immer schnelle und hilfreiche Rückmeldung. Der Tisch bereitet uns wirklich viel Freude😊",
            date: "Dezember 2022"
          },
          25: {
            text: "vielen Dank für den tollen Tisch. Wir sind absolut zufrieden mit unserer Wahl und freuen uns auf viele schöne Gelegenheiten ihn zu nutzen.",
            date: "Dezember 2022"
          },
          24: {
            text: "Wir danken euch für die tollen Möbel und die unkomplizierte und freundliche Kommunikation! Ich liebe die Sachen jetzt schon und freue mich sehr, dass ich euch über Insta gefunden habe!",
            date: "Dezember 2022"
          },
          23: {
            text: "😍 er ist perfekt 😍",
            date: "Dezember 2022"
          },
          22: {
            text: "Unser Tisch ist an seinem neuen Platz... Wir sind immernoch ganz verliebt😊",
            date: "Dezember 2022"
          },
          21: {
            text: "Hallo rho 17, unser Tisch ist heute gekommen. MEGA. Super Arbeit!",
            date: "November 2022"
          },
          20: {
            text: "Vielen herzlichen Dank. Wir freuen uns schon mit Freunden und Familie gemeinsam am großen Tisch sitzen zu können",
            date: "November 2022"
          },
          19: {
            text: "Vielen Dank, der Tisch sieht in echt sogar noch besser aus, als es auf den Bildern rüberkommt. Die perfekte Unperfektheit ist euch mega gelungen:) Das Konzept ist echt klasse",
            date: "Oktober 2022"
          },
          18: {
            text: "Danke für den tollen Tisch! Aufbau war wirklich easy. Wir sind super happy damit, er ist sein Geld wert 😊",
            date: "Oktober 2022"
          },
          17: {
            text: "Wir sind sehr zufrieden mit dem unkomplizierten und netten Kontakt, der problemlosen Lieferung & natürlich auch mit dem Tisch! Er ist genauso, wie wir ihn uns gewünscht haben. Danke!",
            date: "Oktober 2022"
          },
          16: {
            text: "Ich bin so froh, dass ich mich letztendlich doch für deinen Gerüstbohlen-Tisch entschieden habe. Danke auch für die gute Beratung und den perfekten Bausatz - es hat alles super geklappt. Er wurde auch direkt von meinen Fellchen akzeptiert:)",
            date: "September 2022"
          },
          15: {
            text: "Ein Unikat und absolut besonders! Nichts von der Stange, in allen Bereichen. Vielen Dank an Julian für diesen wunderschönen Tisch und die professionelle und unkomplizierte Abwicklung. Nur zu empfehlen.",
            date: "September 2022"
          },
          14: {
            text: "Der Tisch gefällt uns nach wie vor hervorragend! Die Optik ist super und er fühlt sich toll an!",
            date: "August 2022"
          },
          13: {
            text: "Danke für den neuen Tisch",
            date: "August 2022"
          },
          12: {
            text: "Wir sind sehr happy mit dem Tisch und er ist das Herzstück der Wohnung. Vielen Dank nochmal!",
            date: "Juni 2022"
          },
          11: {
            text: "Ich hab meinen schönen Tisch von euch in meiner Keramikwerkstatt. Ich bin super Zufriden mit eurer Arbeit!",
            date: "Mai 2022"
          },
          10: {
            text: "Vielen lieben Dank nochmal! Du hast wirklich ganz tolle Arbeit geleistet und der Tisch ist wunderschön geworden!",
            date: "Mai 2022"
          },
          9: {
            text: "Wir sind super happy damit. Danke noch mal!",
            date: "April 2022"
          },
          8: {
            text: "Bin super happy damit. So perfekt unperfekt!",
            date: "April 2022"
          },
          7: {
            text: "Der Tisch ist ein echter Hingucker. Jeder spricht uns darauf an.",
            date: "März 2022"
          },
          6: {
            text: "Der Tisch Ist heute gekommen und er ist perfekt. Jedes Brett sieht in genauso aus wie auf den Fotos im online Shop.",
            date: "Februar 2022"
          },
          5: {
            text: "Ein wahres Meisterstück schmückt unsere Wohnung! Tolle Arbeit und definitiv die richtige Entscheidung! Wir freuen uns auf viele lange Nächte und unvergessliche Geschichten.",
            date: "Januar 2022"
          },
          4: {
            text: "Super!! Ich bin überglücklich!!!! 😍",
            date: "Dezember 2021"
          },
          3: {
            text: "Hat alles geklappt! Schaut super aus! Vielen Dank! Liebe Grüße, Nicole",
            date: "Oktober 2021"
          },
          2: {
            text: "Der Tisch ist ein Highlight im Wohnzimmer und sehr stabil. Die Bestellung war super einfach, ich konnte mir meine Wunschbretter direkt in der Werkstatt aussuchen. Vielen Dank Julian!",
            date: "August 2021"
          },
          1: {
            text: "Wir sind super zufrieden mit dem Tisch. Er entspricht genau unseren Vorstellungen, ist gut verarbeitet und ein wahres Unikat. Julian hat unsere Wünsche perfekt umgesetzt! Wir werden lange Freude an dem Tisch haben.",
            date: "Juli 2021"
          },
        },
        bench: {
          5: {
            //anja
            text: "die Möbel sind wohl behalten am Samstag hier angekommen. Sie sehen mega aus, alle sind begeistert!!!",
            date: "Februar 2022"
          },
          4: {
            text: "Wir danken euch für die tollen Möbel und die unkomplizierte und freundliche Kommunikation! Ich liebe die Sachen jetzt schon und freue mich sehr, dass ich euch über Insta gefunden habe!",
            date: "Dezember 2021"
          },
          3: {
            text: "Die Bank gefällt uns nach wie vor hervorragend! Die Optik ist super und sie fühlt sich toll an!",
            date: "August 2021"
          },
          2: {
            text: "Ich hatte schon einen Tisch von rho 17 und habe mich sehr gefreut als ich von den Bänken gehört habe. Sie sieht top aus und es hat alles super geklappt, wie mit dem Tisch eben. Vielen Dank!",
            date: "Juli 2021",
          },
          1: {
            text: "Von der Qualität und der Einzigartigkeit des Tisches sind wir so überzeugt gewesen, dass wir auch noch die entsprechende Bank dazu anfertigen lassen haben. Auch bei unseren Gästen kommen Tisch und Bank super an und der erste überlegt schon, sich auch einen solchen Tisch zuzulegen.",
            date: "Juni 2021"
          }
        },
        stool: {
          1: {
            text: "Wir sind sehr happy mit dem Tisch und er ist das Herzstück der Wohnung. Vielen Dank nochmal!",
            date: "Juni 2021"
          }
        }
      },
      imprint: "Impressum",
      datasecurityLink: "Datenschutzerklärung"
    },
    textsEnglish: {
      configurator: {
        title: "Which kind of furniture do you want to configure?",
        table: "Table",
        tableOffice: "Office Table",
        shelf: "Shelf",
        bench: "Bench",
        stool: "Stool",
        frameProduct: "Frame",
        color: {
          title: "Color of frame",
          titleFrame: "Passepartout color",
          standardColor: "Go with a standard color ...",
          CheckboxText: "or choose your own",
          colorInfo: {
            button: "info",
            popupTitle: "Standard colors sample images",
          }
        },
        frame: {
          title: "Tyoe of frame",
          titleFrame: "What goes in the frame?",
          open: "open",
          closed: "closed",
          simple: "simple",
          massiv: "massiv",
          mirror: "mirror",
          whiteboard: "whiteboard",
          blackboard: "blackboard",
          passepartout: "passepartout",
          none: "none"
        },
        priceChip: {
          table: "Your table ",
          tableOffice: "Your table ",
          shelf: "Your Shelf ",
          bench: "Your bench ",
          stool: "Your stool ",
          delivery: "Free delivery within germany",
          deliveryMobile1: "Free delivery",
          deliveryMobile2: "within germany",
        },
        reviews: {
          dimensions: "L x W x H: "
        },
        dimensions: {
          title: "Dimensions",
          individual: "individual",
          dining: "dining",
          office: "office",
          bench2person: "2 persons",
          bench3person: "3 persons",
          stoolNormal: "normal",
          stoolHigh: "high",
          length: "length: ",
          width: "width: ",
          height: "height: ",
          numberOfPlanks1: "with",
          numberOfPlanks2: "scaffolding planks",

        },
        wood: {
          title: "Scaffolding planks",
          numberOfAvailablePlanks1: "Right now there are",
          numberOfAvailablePlanks2: "planks available.",
          numberOfAvailablePlanksBoard: "Plates from scaffolding planks available.",
          choiceOfPlanks: "Your choice:"
        }
      },
      tableConfigurator: {
        configurator : {
          chooseWood: {
            title: "Scaffolding planks",
            abovePlanks: "Each board has been photographed and you can select which one you want to use for your table",
            abovePlanksTitle: "Select each scaffolding plank individually"
          },
          addedToCart: {
            title: "Added table to cart",
            info: "Your table has been successfully added to cart. We also offer matching benches and stools. You can configure them as conveniently as the table. Plus you'll get a 10% discount for each cheaper product in your cart.",
            close: "Close",
            furtherProducts: "Further products",
            furtherProductsMobile: "Products",
            toCart: "To cart",
            toCartMobile: "To cart"
          },
          startConfigurator: "Start configurator",
          backgroundInfo: "More about our tables",
          reviews: "Reviews"
        },
        infoTeaser: "Easily configure your preferred dimensions for your table, no matter whether you need a table for dining, the kitchen or the office.",
        infoSizeTitle:"Size:",
        infoSizeText: "Select the desired height, width and length - perfectly fitting for your kitchen, dining- or livingroom. A length of 1.80m is suitable for roughly 3 chairs next to each other. 2 persons are comfortably sitting at a 1.30m table.",
        infoPlanksTitle: "The scaffolding planks:",
        infoPlanksText: "Our tables are made from old scaffolding planks. We get them from a partner company and upcycle them in our workshop. Each board is individual with its used look and splashes of color. This creates a unique piece of furniture perfect for your home.",
        infoFrameTitle: "Our frames:",
        infoFrameText1: "The frames are made of powder coated steel and are available in many different colors. Choose your preffered hue and create a special atmosphere in your home. We offer two types of frames; either open or closed.",
        infoFrameText2: "Feel free to contact us if you have any special needs or further ideas. We will then get back to you and see what we can do. Each piece of furniture is handmade in our workshop and will be delivered to you within 6 weeks. The delivery will take place on a date specified by you. Alternatively you can pick up your order at our workshop in Berlin.",
        bulletpoints: ["For each order a tree gets planted",
                        "Upcycling is sustainable",
                        "Each scaffolding plank is individual",
                        "10% discount for further products",
                        "Handmade with love",
                        "Free delivery within germany"],
      },
      tableOfficeConfigurator: {
        configurator : {
          chooseWood: {
            title: "Table top from scaffold planks",
            abovePlanks: "Each table top has been photographed so you can choose exactly which one is right for you.",
            abovePlanksTitle: "Choose your table top"
          },
          addedToCart: {
            title: "Added table to cart",
            info: "Your table has been successfully added to cart. We also offer matching benches and stools. You can configure them as conveniently as the table. Plus you'll get a 10% discount for each cheaper product in your cart.",
            close: "Close",
            furtherProducts: "Further products",
            furtherProductsMobile: "Products",
            toCart: "To cart",
            toCartMobile: "To cart"
          },
          startConfigurator: "Start configurator",
          backgroundInfo: "More about our desks",
          reviews: "Reviews"
        },
        backgroundInfo: "More about our desks",
        infoTeaser:"The rho 17 height adjustable desk features a unique, sustainable work surface.",
        infoSizeTitle:"Table top:",
        infoSizeText: "The top is made from old, reclaimed scaffolding planks that have been glued together to create a flat surface that will conjure up a warm, cozy look in your office or home office.",
        infoPlanksTitle: "The scaffolding planks:",
        infoPlanksText: "Every scaffold plank tells a story. They are not perfect, they have signs of wear, but that is what makes them so uniquely beautiful. The planks are made from a variety of sturdy softwoods, mostly pine or spruce, and are reconditioned and prepared for their new use in our workshop. (Since they are naturally aged wood, there may be slight imperfections, but they are hardly noticeable).",
        infoFrameTitle: "The frame:",
        infoFrameText1: "The height of the frame can be electronically adjusted between 65 and 125 cm to achieve an ergonomically correct working posture. This makes it possible to work comfortably not only while sitting, but also while standing. The frame is available in white and black. It is a frame from IKEA, which allows for a favorable price and easy assembly.",
        bulletpoints: ["For each order a tree gets planted",
                        "Upcycling is sustainable",
                        "Each scaffolding plank is individual",
                        "10% discount for further products",
                        "Handmade with love",
                        "Free delivery within germany"],
      },
      shelfConfigurator: {
        configurator : {
          chooseWood: {
            title: "Scaffolding planks",
            abovePlanks: "Each board was photographed, so you can choose exactly which one to use for your shelf.",
            abovePlanksTitle: "Choose each scaffold plank individually"
          },
          addedToCart: {
            title1: "Shelf added to shopping cart",
            info: "Your shelf has been successfully added to the shopping cart. We also offer matching tables, stools and benches. These can be configured just as conveniently as the shelf. And if you buy more than one product, there is a 10% quantity discount on all cheaper furniture pieces.",
            close: "Close",
            furtherProducts: "Further products",
            furtherProductsMobile: "Products",
            toCart: "To cart",
            toCartMobile: "To cart"
          },
          startConfigurator: "Start configurator",
          backgroundInfo: "More about our shelves",
          reviews: "Reviews"
        },
        infoTeaser: "The rho 17 shelf - the new addition to the rho family. As with all our products, you have the possibility to make individual adjustments and design the shelf according to your own ideas, suitable for your room.",
        infoSizeTitle:"Size:",
        infoSizeText: "Our sample shelf is 2m wide and 1.8m high. The frame was finished with a matte clear lacquer. Whether bookshelf, for your plants or decoration, here finds on up to 10 shelves everything that is dear to you.  It's best to think about how long the entire shelf should be and how many compartments you need. The width of the shelf is adjustable from 60cm to 220cm, the height can be adjusted up to 150cm m. You also have the option to add a middle column from a length of 100cm to get more stability. And as if that were not enough, you can also make your shelf asymmetrical and shorten individual shelves, and even the outer columns.",
        infoPlanksTitle: "The scaffolding planks:",
        infoPlanksText: "Our shelves are made of old scaffolding planks, which we buy from our partner from Brandenburg and refurbish. Each plank is unique with its traces of wear, holes and splashes of color and makes each piece of furniture unique. You have the possibility to choose every single plank for your shelf in our configurator.",
        infoFrameTitle: "The frame:",
        infoFrameText: "The frames are made of powder-coated steel and are available in different colors. Choose your favorite color from the color fan and set colorful accents in your home.",
        infoDeliveryTitle:"Delivery:",
        infoDeliveryText:"Each piece of furniture is individually handmade in our workshop in Berlin and will be with you no later than 6 weeks after receipt of order. The delivery takes place with our shipping partner at your desired date. It is also possible to pick up your new shelf personally in our workshop.",
        bulletpoints: ["For each order a tree gets planted",
                        "Upcycling is sustainable",
                        "Each scaffolding plank is individual",
                        "10% discount for further products",
                        "Handmade with love",
                        "Free delivery within germany"],
      },
      frameConfigurator: {
        configurator : {
          chooseWood: {
            title: "Gerüstbohlen",
            abovePlanks: "Jedes Brett wurde fotografiert, so kannst du genau auswählen welches für dein Regal eingesetzt werden soll.",
            abovePlanksTitle: "Wähle jede Gerüstbohle individuell"
          },
          addedToCart: {
            title1: "Regal zum Warenkorb",
            title2: "hinzugefügt",
            info: "Dein Regal wurde erfolgreich zum Warenkorb hinzu gefügt. Wir bieten passend hierzu auch Tische, Hocker und Bänke an. Diese lassen sich genauso komfortabel konfigurieren wie das Regal. Und bei mehreren Produkten gibt es auf alle günstigeren Möbestücke 10% Mengenrabatt.",
            close: "Schliessen",
            furtherProducts: "Weitere Produkte",
            furtherProductsMobile: "Produkte",
            toCart: "Zum Warenkorb",
            toCartMobile: "Warenkorb"
          },
          startConfigurator: "Konfigurator starten",
          backgroundInfo: "Mehr zu unseren Regalen",
          reviews: "Rezensionen"
        },
        infoTeaser: "Das rho 17 Regal - der Neuzugang in der rho-Familie. Wie bei allen unseren Produkten, hast du auch hier die Möglichkeit individuelle Anpassungen vorzunehmen und das Regal nach deinen eigenen Vorstellungen, passend für deinen Raum zu gestalten.",
        infoSizeTitle:"Größe:",
        infoSizeText: "Unser Musterregal ist 2m breit und 1,8m hoch. Das Gestell wurde mit einem matten Klarlack veredelt (Option: “Klar” im Konfigurator). Ob Bücherregal, für deine Pflanzen oder Deko, hier findet auf bis zu 10 Regalbrettern alles Platz, was dir lieb ist.  Überlege dir am besten, wie lang das gesamte Regal sein soll und wie viele Fächer du benötigst. Die Breite des Regals ist von 60cm bis 220cm einstellbar, die Höhe lässt sich bis 150cm m einstellen. Du hast außerdem die Möglichkeit ab einer Länge von 100cm eine mittlere Säule einzubauen, um mehr Stabilität zu erhalten. Und als wäre das nicht schon genug, kannst du dein Regal auch asymmetrisch gestalten und einzelne Regalbretter, und sogar die äußeren Säulen, kürzen.",
        infoPlanksTitle: "Die Gerüstbohlen:",
        infoPlanksText: "Unsere Regale bestehen aus alten Gerüstbohlen, die wir von unserem Partner aus Brandenburg abkaufen und aufarbeiten. Jede Bohle ist mit ihren Abnutzungsspuren, Löchern und Farbklecksen einzigartig und macht jedes Möbelstück zu einem Unikat. Du hast in unserem Konfigurator die Möglichkeit, jedes einzelne Brett für dein Regal auszuwählen.",
        infoFrameTitle: "Das Gestell:",
        infoFrameText: "Die Gestelle bestehen aus pulverbeschichtetem Stahl und sind verfügbar in verschiedenen Farben. Wähle aus dem Farbfächer deine Lieblingsfarbe aus und setze bunte Akzente in deinem Zuhause.",
        infoDeliveryTitle:"Lieferung:",
        infoDeliveryText:"Jedes Möbelstück wird individuell von Hand in unserer Werkstatt in Berlin gefertigt und ist spätestens 8 Wochen nach Auftragseingang bei dir. Die Lieferung erfolgt mit unserem Speditionspartner zu deinem Wunschtermin. Es ist außerdem möglich dein neues Regal persönlich in unserer Werkstatt abzuholen.",
        bulletpoints: ["Für jede Bestellung wird ein Baum gepflanzt",
                        "Upcycling ist nachhaltig",
                        "Jede Gerüstbohle ist individuell",
                        "10% Preisnachlass bei mehreren Produkten",
                        "Mit Liebe handgefertigt in Berlin",
                        "Gratis Versand bis in die Wohnung"],
                        // "noch vor Weihnachten bei dir"],
      },
      benchConfigurator: {
        configurator : {
          chooseWood: {
            title: "Scaffolding planks",
            abovePlanks: "Each board has been photographed and you can select which one you want to use for your bench",
            abovePlanksTitle: "Select each scaffolding plank individually"
          },
          addedToCart: {
            title: "Added bench to cart",
            info: "Your bench has been successfully added to cart. We also offer matching tables and stools. You can configure them as conveniently as the bench. Plus you'll get a 10% discount for each cheaper product in your cart.",
            close: "Close",
            furtherProducts: "Further products",
            furtherProductsMobile: "Products",
            toCart: "To cart",
            toCartMobile: "To cart"
          },
          startConfigurator: "Start configurator",
          backgroundInfo: "More about our benches",
          reviews: "Reviews"
        },
        info1: "Our benches do not only fit perfectly with the rho 17 tables, but they also complement with other furniture as well. The benches, made of scaffolding planks, are also suitable as a seating possibility in an entrance area.",
        info2: "With our configurator you have the choice to decide which unique scaffolding plank is your favourite, pick a length between 1m and 2.2m then choose the color and type of frame.",
        info3: "Our scaffolding planks have been in use for many years allowing them to be weathered and seasoned over time. This is what gives each individual plank its unique aesthetic. Sometimes with age can come detrition, so we make sure each plank is inspected for long lasting integrity. We treat each board individually with care and take a picture of it so you can choose your favourite one. We then build your individual rho 17 product.",
        info4: "Each scaffolding plank is unique with its used look and splashes of color. The delivery will happen 6 weeks after order with our logistic partner on a date specified by you.",
        info5: "Alternatively it is possible to pick up your bench by yourself in Berlin.",

        infoTeaser: "Our benches do not only fit perfectly with the rho 17 tables, but they also complement with other furniture as well. The benches, made of scaffolding planks, are also suitable as a seating possibility in an entrance area.",
        infoContinue: "YWith our configurator you have the choice to decide which unique scaffolding plank is your favourite, pick a length between 1m and 2.2m then choose the color and type of frame. Our scaffolding planks have been in use for many years allowing them to be weathered and seasoned over time. This is what gives each individual plank its unique aesthetic. Sometimes with age can come detrition, so we make sure each plank is inspected for long lasting integrity. We treat each board individually with care and take a picture of it so you can choose your favourite one. We then build your individual rho 17 product. Each scaffolding plank is unique with its used look and splashes of color. The delivery will happen 6 weeks after order with our logistic partner on a date specified by you. Alternatively it is possible to pick up your bench by yourself in Berlin.",
        bulletpoints: ["For each order a tree gets planted",
                        "Upcycling is sustainable",
                        "Each scaffolding plank is individual",
                        "10% discount for further products",
                        "Handmade with love",
                        "Free delivery within germany"],
      },
      stoolConfigurator: {
        configurator : {
          chooseWood: {
            title: "Scaffolding planks",
            abovePlanks: "Each board has been photographed and you can select which one you want to use for your stool",
            abovePlanksTitle: "Select each scaffolding plank individually"
          },
          addedToCart: {
            title: "Added stool to cart",
            info: "Your stool has been successfully added to cart. We also offer matching tables and benches. You can configure them as conveniently as the stool. Plus you'll get a 10% discount for each cheaper product in your cart.",
            close: "Close",
            furtherProducts: "Further products",
            furtherProductsMobile: "Products",
            toCart: "To cart",
            toCartMobile: "To cart"
          },
          startConfigurator: "Start configurator",
          backgroundInfo: "More about our stools",
          reviews: "Reviews"
        },
        info1: "Our stools are not only perfectly fitting to the rho 17 tables, but they also match with other furnitures as well. Or as a sitting possibility in the entrance area next to a scaffolding bench from rho 17.",
        info2: "When designing your own stool you can individually select your favorite scaffolding plank and chose between two types of frames as well as the color of it.",
        info3: "Our scaffolding planks were serving at least 10 years on construction sites and have been sorted out recently. But they are still strong enough to serve as long lasting furnitures.",
        info4: "We're treating each board individually with care and take a picture of it so you can choose your favorite one. Then we will build your rho 17 individual product. Each scaffolding plank is unique with its used look and splashes of color. The delivery will happen 6 weeks after order with our logistic partner on a date specified by you.",
        info5: "Furthermore it is possible to pick up your bench by yourself in Berlin.",
        infoTeaser: "Our stools are not only perfectly fitting to the rho 17 tables, but they also match with other furnitures as well. Or as a sitting possibility in the entrance area next to a scaffolding bench from rho 17.",
        infoContinue: "When designing your own stool you can individually select your favorite scaffolding plank and chose between two types of frames as well as the color of it. Our scaffolding planks were serving at least 10 years on construction sites and have been sorted out recently. But they are still strong enough to serve as long lasting furnitures. We're treating each board individually with care and take a picture of it so you can choose your favorite one. Then we will build your rho 17 individual product. Each scaffolding plank is unique with its used look and splashes of color. The delivery will happen 6 weeks after order with our logistic partner on a date specified by you. Furthermore it is possible to pick up your bench by yourself in Berlin.",
        bulletpoints: ["For each order a tree gets planted",
                        "Upcycling is sustainable",
                        "Each scaffolding plank is individual",
                        "10% discount for further products",
                        "Handmade with love",
                        "Free delivery within germany"],
      },
      cart: {
        orderSuccess: "Thank you very much for your order. We will reach out to you via email soon. Feel free to contact us if you have any further questions.",
        originTitle: "Please tell us how you've got to know about us",
        originFacebook: "Facebook",
        originInstagram: "Instagram",
        originGoogle: "Search engine",
        originFriends: "Friends",
        originOther: "Other",
        originSubmit: "Done",
        orderFailure: "Unfortunately something went wrong with the payment. Please contact us or try it again.",
        productLink: "To our products",
        checkoutNow1: "Order for ",
        checkoutNow2: "€",
        checkoutWidthShipping: "Price includes shipment, Paypal buyers protection and VAT.",
        checkoutWidthoutShipping: "Price includes Paypal buyers protection and VAT.",
        noProductsInCart: "You don't have any products in your cart yet",
        productList: {
          yourCart: "Your cart",
          dimensions: "L x W x H: ",
          dimensionsShelf: "W x H x D: ",
          colorShelf: "Frame color: ",
          shelfNumberPillars: "Number of columns: ",
          shelfNumberBoards: "Number of shelves: ",
          frame: "Frame: ",
          color: "Color: ",
          price: "Price: ",
          originalPrice: "Original price: ",
          discount: "Discount: ",
          discountPrice: "Your price: "
        },
        contactForm: {
          firstName: "First ame",
          lastName: "Last name",
          country: "Country",
          mail: "email",
          shipping: "Send via logistic company",
          outsideGermany: "Delivery outside Germany",
          expressBuildNo: "Free delivery within 8 weeks",
          pickUp: "Pickup close to Berlin (-€",
          outsideGermanyText: 'Fill out all data and click the button "Reserve". We will then make you an individual offer including delivery.',
          pickUpAdress1: "You can pick up your order at",
          pickUpAdress2: "Fernstr. 27",
          pickUpAdress3: "15741 Bestensee",
          streetAndNumber: "Street and number",
          zip: "ZIP",
          city: "City",
          phone: "Phone",
          voucher: "Voucher",
          applyVoucher: "Redeem",
          voucherSubtracted1: "",
          voucherSubtracted2: "€ have been credited",
          discountSubtracted1: "A discount of",
          discountSubtracted2: "€ has been subtracted",
          message: "Do you want to tell us anything else?",
          datasecurity: "I have read the Terms of Use and Data Privacy Statement and accept these conditions"
        },
        buyViaTransfer: "Complete purchase by bank transfer",
        reserve: "Reserve",
        orderReserved: "Your order has been successfully reserved. We will get back to you soon with a quote."
      },
      faq: {
        title: "Faq",
        text: "We try to keep the webpage as informative as possible. Sometimes you may want to have more detailed information, therefore you find a collection of the most frequently asked questions and answers here.",
        planks: {
          title: "Questions regarding scaffolding planks",
          text: "Unique products - more than 10 years old.",
          info: [
            {
              title: "Where do the  planks come from?",
              text: "We're receiving the scaffolding planks from a local trader around Berlin. He is buying and selling scaffoldings usually from and to construction sites. But since some time, some of the planks find their way to be transformed to a furniture."
            },
            {
              title: "How are they being treated?",
              text: "First we sand the planks roughly to get rid of the dusty first layer. Then there comes a second, more smooth sanding step and one layer of high solid oil treatment. Once this treatment is dry, we tale a picture of the scaffolding plank and upload it to our webpage. After your order we trim the plank to fit your desired furniture and sand it a second time smoothly. It then gets oiled a second time. The scaffolding plank is now ready to be mounted."
            },
            {
              title: "What are they treated with?",
              text: "We are treating the scaffolding planks with clear, mate high solid oil from Osmo. We decided for this oil and brand because it has a high quality and is even suitable for children toys regarding to EURO-Norm EN 71.3."
            },
            {
              title: "What wood are the scaffolding planks made off?",
              text: "They are made of pine wood. Because of the many years they have been exposed to wheather, they were getting a bit more dark and contrasty over time."
            },
            {
              title: "Can I have a sample piece?",
              text: "If you're not sure whether the color of the wood matches with your home, we are happy to send you a sample peice for free. Just provide us with your address and we take care of everything else."
            }
          ]
        },
        frames: {
          title: "Questions regarding the frame",
          text: "Individually crafted from our partner company.",
          info: [
            {
              title: "What material are the frames made of?",
              text: "The frames for our furnitures are made of steel which is welded together. We let the frames be produced by a professional locksmith business."
            },
            {
              title: "How is the surface of the frame treated?",
              text: "The frames are powder coated. This ensures a high quality and very durable finish to have a longlasting product."
            },
            {
              title: "How do I deal with an uneven floor?",
              text: "We know and love these old but sometimes a bit uneven floors. In order to be able to adjust and level your furnitures, they are all equipped with adjustable feets made of rubber material."
            }
          ]
        },
        configurator: {
          title: "Questions regarding the configurator",
          text: "As much choosability as possible.",
          info: [
            {
              title: "Are there other sizes possible?",
              text: "Yes. The configurator limits the dimensions, but we also produce other sizes on request as well. Please have in mind, that the scaffolding planks we use allow a max. length of 2.20m boards. If you want to have a longer table you can reach out to us and we will provide you with a specific offer."
            },
            {
              title: "Can I have just scaffolding planks?",
              text: "You might have a frame already and want to continue using it. We sell single scaffolding planks as well. They are cut to your desired size and sanded as well as finished just like with a normal table. They cost 200€ each incl. delivery. Just contact us and we provide you with further details."
            },
            {
              title: "Are there other shapes possible?",
              text: "We dont want to limit your creativity. Please send us your desired design (just a sketch or a picture from a comparable product) and we'll provide you with a specific offer."
            },
            {
              title: "Is there another frame possible",
              text: "As with the shape of the table, we don't want to limit you with the frame either. Just tell us your ideas (via phone, whatsapp or mail) and we will take care of everything else."
            }
          ]
        },
        shipment: {
          title: "Questions regarding payment and delivery",
          text: "It should all be as easy as possible.",
          info: [
            {
              title: "Is there a shipment insurance?",
              text: "We've sent already many tables with our logistic partner and so far there hasn't been any noteworthy damage. If there might still something happen, we will be liable for the damage."
            },
            {
              title: "When will the delivery be organised?",
              text: "As soon as your order is almost completed, we will contact you and arrange a specific date and time for delivery."
            },
            {
              title: "When do the furnitures arrive?",
              text: "Our logistic partner deliveres whenever needed. Also in the evening and on the weekends. We want you to get your order as easy as possible, therefore we don't hesitate to take over any possible additional fees."
            },
            {
              title: "Will it be delivered into my apartment?",
              text: "Yes. your order will be delivered to its final destination within germany. It will also arrive already mounted."
            },
            {
              title: "Is it possible to pick it up myself?",
              text: "You're in Berlin or wan want to visit this city anyway? You're very welcome to come bye and pick up your order yourself. Since we save the costs for our logistic partner then, it gets cheaper for you as well then off course. During checkout, just click on the button to pick it up yourself. We're always happy to receive guests in our workshop. You can also just pop in anytime and see how your table is progressing. Furthermore you can come bye and choose your scaffolding planks for your furnitures yourself and in live."
            },
            {
              title: "Do you also deliver outside Germany?",
              text: 'Yes, but we need to get an individual quote from the shipping company. Simply configure your furniture, enter your address at the checkout and, if necessary, a message. Then check the box "Delivery outside Germany" and complete the process with the button "reserve". We will contact you with an individual offer including delivery.'
            }
          ]
        },
        other: {
          title: "Further questions",
          text: "Such an investment should be well thought through.",
          info: [
            {
              title: "Is there a discount on bigger orders?",
              text: "Fur sure! For each order which consists of more than one product, the cheaper products get a discount of 10%."
            },
            {
              title: "What if I'm not happy with my product?",
              text: "We don't want anything more than satisfied customers. Not only because we ourselves believe in our products, but also because we think best marketing is happening through happy customers and their referrals. All the furnitures are unique ones and therefore taking them back is not that simple. We try to keep you from any bad surprises with making pictures of the offered scaffolding planks beforehand and also providing many pictures of already shiped tables. If there is still something wrong with the product you received, please don't hesitate to contact us. We're sure that we'll find a solution which leaves all of us happy in the end."
            }
          ]
        },
        additionalIdeas: "Do you have any further questions? Feel free to contact us",
        phone: "phone",
        mail: "email"
      },
      about: {
        title: "Unique furniture taylored to your needs",
        subtitle: "It is our vision to enrich your living space with an individual and suastainable concept.",
        history: {
          title: "rho 17 - every product is unique",
          text: "Our furniture is timeless and is always custom made by us and configured only by you. They are produced to a very high standard in our workshop in Berlin."
        },
        julian: {
          title: "This is rho 17 - coding meets handcrafting",
          text1: "Our founder Julian has many talents. For a long time his passion has been to design and produce furniture. As a child he could already be found in the garden building two-story treehouses as well as supporting his parents to renovate buildings and equipping them with his self-made furniture. When he got his first computer he started using 3D software to be able to design more complex products. Studying mechanical engineering enabled him to combine knowledge about materials and their physics with his design ideas and handcrafting skills. During his studies he founded rho 17 with some friends. He also furnished several cafés, developed individual interior concepts and supported the building process of Monticule music festival in France",
          text2: "After further education in the field of software engineering he developed the first version of the rho 17 online experience. It was a configurator for tables that perfectly combined his multiple passions.",
          text3: "And we arrived here. Now with a bigger team, our own workshop, more products and more to come ;)",
        },
        team: {
          title: "The team",
          text1: "rho 17 was founded as a collective and keeps on with the idea of creating something together. We all put a lot of love and effort into creating sustainable furniture and always question and improve our work processes as well as the furniture themself.",
          text2: "Together we want to create sustainable and long lasting furniture with having individual needs of our customers in mind. Each rho 17 product is unique and handmade.",
          julianTitle: "Julian",
          julianText: "Founder",
          wingTitle: "Wing",
          wingText: "Production expert",
          friederTitle: "Frieder",
          friederText: "Bee whisperer",
          elliTitle: "Elli",
          elliText: "Art director",
          justusTitle: "Justus",
          justusText: "Sanding king",
        },
        furtherQuestions: "Do you have a question? Contact us here:",
        phone: "phone",
        mail: "e-mail"
      },
      sustainability: {
        title: "We care!",
        subTitle1: "We chose to upcycle old scaffolding planks because we love the environment.",
        subTitle2: "Because we plant trees, each piece of rho 17 furniture is not only an investment into your home,",
        subTitle3: "but also into the future of our planet.",
        longLasting1: "Our furniture is   and outlasts trends. The high quality ensures a use over many years and the timeless design matches different styles of living with ease.",
        longLasting2: "And that’s not all: the longer you use your table, the more beautiful it gets.",
        planksCounter: "upcycled scaffolding planks during the previous month",
        planksTitle: "Our scaffolding planks",
        planksText1: "The boards have history. They are not perfect, but the marks of use are what makes them uniquely beautiful. We decided for this material, because we love the rough industrial look of this wood, and of course its sustainability. The boards are still robust, so they can be easily reused for furniture.",
        planksText2: "After about 15 years they get sorted out because they cant fulfill the high loads of scaffolding any more. We're personally selecting the boards and we value the individual marks they got after this long time of usage. They consist of pinewood and get prepared for their new use in our workshop.",
        planksText3: "Because we reuse existing material, we save resources and create something new at the same time - Individual handmade with love.",
        treesCounter: "planted trees during the previous month",
        treesText1: "Of course we know that for the scaffolding plank there was a tree cut at some point, that's why we want to give something back. With each order we support the carbon offset project Plant-My-Tree.",
        treesText2: "We work closely with this organisation and will visit the area of reforestation soon.",
        treesText3: "You'll get a certificate from Plant-My-Tree with each purchase.",
        otherCounter1: "rho 17 runs with",
        otherCounter2: "kWh renewable energy",
        otherText1: "Climate protection doesn't stop there. Our runs with renewable energy and we're planning to have a system as well. Furthermore we are optimising packaging material to use more and more recycled material, as-well-as less and less packaging!",
        otherText2: "To treat our furniture, we use our own beeswax oil, which is produced in-house and developed in close collaboration with a beekeeper friend. It is made on the basis of renewable raw materials and is mixed without machines. Bees are essential for a functioning ecosystem. These ecosystems and the organisms found in these habitats provide, among other things, for oxygen, clean water, regulate the climate and provide food and medicines. That is why we not only plant bee-friendly flowers in the front yard of our workshop, but also have our own beekeeper on the team.",
        beesLink: "More about our bees",
        furtherIdeas: "Any suggestions on how to increase our sustainability further?",
        submitFurtherIdeas: "send",
        furtherIdeasLabel: "Your message to us"
      },
      bees: {
        title: "rho bees",
        introTitle: "The rho 17 furniture wax",
        intro1: "Sustainability and bees somehow belong together. But tables and bees? rho 17 and bees?",
        intro2: "Yes, from now on and we're pretty proud of it.",
        waxText1: "Our new surface treatment for our furniture is now manufactured in-house and consists solely of beeswax and linseed oil. That's it!",
        waxText2: "Together with our friend, bee expert and beekeeper Frieder, we have developed an organic wax that meets our high standards and properly seals, impregnates and protects the tables, benches and stools.",
        waxBulletsTitle: "Our furniture wax is:",
        waxBullets: ["food safe", "low odor", "100% natural", "solvent-free", "easy to process", "based on renewable raw materials"],
        waxText3: "The beeswax oil is produced in our workshop with a lot of love, work and experience.",
        friederTitle:"About Frieder & his bees:",
        friederText1:"We are happy to have Frieder with his thirst for action and his bee expertise on the team. Frieder’s apiary is located in a lovingly designed vegetable and fruit garden on the outskirts of Berlin. All around there are linden and chestnut avenues, robinia groves, the characteristic pine forests, some agriculture and wild meadows.",
        friederText2:"Frieder has been passionate about beekeeping and the resulting ecological relationships since his youth. He keeps beekeeping for the most part according to Demeter specifications and currently has 6 colonies of native “dark bees” that descend from the Carnica honeybee.",
        friederText3:"In addition to Frieder's raw material, we also use other beeswax from beekeepers: inside from the region and combine it with high-quality linseed oil.",
        honeyTitle:"Frieder’s honey",
        honeyText:"As a little specialty, our customers will now receive a glass of Frieder’s delicious honey with every order.",
        honeyBullets:["Aromatic and nutty", "Creamy", "Summer honey"],
        furtherQuestions: "Do you still have questions? Please contact us:",
        phone: "phone",
        mail: "e-mail"
      },
      main: {
        intro: {
          title1: "Unique furniture",
          title2: "from scaffolding planks",
          subTitle1: "rho 17 combines high class design with sustainability.",
          subTitle2: "We build long lasting, industrial style furniture,",
          subTitle3: "individually crafted according to your needs.",
          link: "Configure now",
          delivery: "Delivery in 6 weeks within germany"
        },
        material: {
          title: "upcycled scaffolding planks during the previous month",
          text1: "Upcycling = sustainability. We don't use new wood, but we give old scaffolding planks a new life.",
          text2: "We refurbish the material, leaving the patina, the small cracks and the splashes of color just so the boards keep their unique look and atmosphere."
        },
        sustainability: {
          title: "new trees in the past month",
          text1: "We care! We support a local carbon offset project with each order.",
          text2: "Our partner Plant-My-Tree is planting trees in the Niederlausitzer Heidelandschaft.",
          link: "More about this project"
        },
        about: {
          title: "rho 17 - coding meets handcrafting",
          text: "We want to enrich you with our individual and sustainable furniture concept. You can configure your table, bench or stool just as you need them, and can even choose each scaffolding plank individually. Every piece of furniture gets crafted by hand in our workshop in Berlin and will be delivered within 6 weeks to your home.",
          link: "More about us"
        },
        furnitureConfigurator: {
          title: "Custom furniture from scaffolding planks",
          text: [
            "Our furniture is always made individually according to your desired dimensions.",
            "Whether desk or dining table, whether bench, stool or shelf - your desired dimensions determine the size of the furniture. You can design everything yourself with our configurator: from the dimensions, to the frame shape and color, to every single frame plank used - you're the boss.",
            "Configure your new rho 17 unique now."
          ],
          link: "Let's go"
        },
        tableConfigurator: {
          title: "Plan your new table!",
          text: [
            "Whether desk or dining table, whether large family or single household - your desired dimensions determine the size of the table. Whether a new table for your home office or finally the long-awaited dinner table for all your friends. Our tables are always made individually according to your ideas and wishes.",
            "In addition to the dimensions, you can also specify each individual plank, which we will then finish and match with the frame made especially for you.",
            "The frames are made of powder-coated steel and are available in various designs and colors. White you find too boring? No problem. Just choose your favorite color.",
            "All furniture is handmade with love in our Berlin workshop."
          ],
          link: "Configure now"
        },
        sittingConfigurator: {
          title: "Take a seat - the rho 17 seats",
          text: [
            "We're offering benches and stools to match our tables.",
            "As with the tables, you choose many people you want the bench to be for.",
            "Make a colorful statement in your kitchen or dining room with our powder coated frames in your desired color.",
            "Of course you can chose the scaffolding plank individually as well.",
            "Everything will arrive within 6 weeks."
          ],
          link: "Configure now"
        },
        instagram: "Visit us on Instagram",
        footer: {
          title: "Feel free to contact us if you have any further questions:",
          phone: "phone",
          mail: "email"
        }
      },
      reviews: {
        table: {
          29: {
            //Hanna 160 80 75
            text: "Am still totally thrilled 😊",
            date: "February 2021"
          },
          28: {
            //anja
            text: "the furniture is probably kept arrived here on Saturday. They look mega, everyone is thrilled!!!",
            date: "February 2021"
          },
          27: {
            //claudia 220 100 75
            text: "My table arrived last Saturday with the shipping company well. He looks just great. We are very happy.",
            date: "January 2021"
          },
          26: {
            text: "I'm super happy with the table, it fits perfectly into our livingroom. Hats off to your work! Delivery was without any problem, the guys came here on time and were carrying up the heavy table. Thank you again, also for your fast and helpful responses. The table is truly making us happy😊",
            date: "December 2020"
          },
          25: {
            text: "Thank you very much for the beautiful table. Wer're absolutely happy with our choice and are looking forward to many nice circumstances to use it.",
            date: "December 2020"
          },
          24: {
            text: "We want to thank you for the nice furnitures and the easy and friendly communication! I love the furnitures already and I'm happy that I found you on Instagram!",
            date: "December 2020"
          },
          23: {
            text: "😍 it is perfect 😍",
            date: "December 2020"
          },
          22: {
            text: "Our table is at it's designated place.. Wer're still totally in love😊",
            date: "December 2020"
          },
          21: {
            text: "Hi rho 17, our table arrived today. MEGA. Very good work!",
            date: "November 2020"
          },
          20: {
            text: "Thank you very much. We're already looking forward sitting on this big table with all our friends and family.",
            date: "November 2020"
          },
          19: {
            text: "Thanks a lot. The table looks even better than on the pictures. You mastered the perfect inperfection:) The concept is great",
            date: "October 2020"
          },
          18: {
            text: "Thanks for the very nice table! We're super happy with it, and it's worth every penny 😊",
            date: "October 2020"
          },
          17: {
            text: "We're very happy with the easy communication, the smooth delivery and, of course the table itself. It is exactly how we wished it to be. Thank you!",
            date: "October 2020"
          },
          16: {
            text: "I'm so happy that I decided for a table made from scaffolding planks in the end. Thank you for the good consultation, everything worked out perfectly. It also got directly accepted from Fellchen:)",
            date: "September 2020"
          },
          15: {
            text: "A unique product, absolutely special. Thank you very much Julian for this wonderful table and the professional process. I can only recommend you.",
            date: "September 2020"
          },
          14: {
            text: "We still like the table a lot! It has a very nice look and the haptics is great too!",
            date: "August 2020"
          },
          13: {
            text: "Thank you very much for our new table!",
            date: "August 2020"
          },
          12: {
            text: "We're very happy wih the table and it is the heart of our apartment. Thank you very much!",
            date: "June 2020"
          },
          11: {
            text: "I got the table for my ceramics workshop and I'm very happy with your work!",
            date: "May 2020"
          },
          10: {
            text: "Thank you very much again! You did a great job and the table turned out to be super beautiful!",
            date: "May 2020"
          },
          9: {
            text: "We're super happy with it. Thanky again!",
            date: "April 2020"
          },
          8: {
            text: "I'm super happy. So perfectly imperfect!",
            date: "April 2020"
          },
          7: {
            text: "The table is a real eye-catcher. Everybody is asking us about it.",
            date: "March 2020"
          },
          6: {
            text: "The table arrived today and it is perfect. Every board looks exactly as in the pictures of the configurator.",
            date: "February 2020"
          },
          5: {
            text: "A truly masterpiece enriches our apartment! Good job, it was definitely the right choice. We're looking forward for long nights and unforgettable stories.",
            date: "January 2020"
          },
          4: {
            text: "Super!! I'm extremely happy!!!! 😍",
            date: "December 2019"
          },
          3: {
            text: "Everything worked out! Looks great! Thank you! Best regards, Nicole",
            date: "October 2019"
          },
          2: {
            text: "The table is a highlight in our living room and very stable. DThe ordering was super easy and I could choose my desired planks directly in the workshop. Thank you Julian!",
            date: "August 2019"
          },
          1: {
            text: "We're super happy with the table. It reflects exactly our expectations, is well made and a really unique product. Julian was fulfilling our wishes perfectly! We'll enjoy this table for a long time.",
            date: "July 2019"
          },
        },
        bench: {
          5: {
            //anja
            text: "the furniture is probably kept arrived here on Saturday. They look mega, everyone is thrilled!!!",
            date: "February 2021"
          },
          4: {
            text: "We want to thank you for the beautiful furnitures and the friendly communication! I love them already and I'm very happy that I found you on Instagram!",
            date: "December 2020"
          },
          3: {
            text: "We still like the bench a lot! It looks perfect and has a nice haptical feeling as well!",
            date: "August 2020"
          },
          2: {
            text: "I already had a table from rho 17 and was very happy once I heard about the benches. It looks very good and everything worked out perfectly (like with the table as well). Thanks a lot!",
            date: "July 2020",
          },
          1: {
            text: "We were so convinced of the quality and uniqueness of the table, so we additionally ordered a matching bench. Also our guests like the table and bench a lot, some of them already think of ordering a table too;)",
            date: "June 2020"
          }
        },
        stool: {
          1: {
            text: "Wir sind sehr happy mit dem Tisch und er ist das Herzstück der Wohnung. Vielen Dank nochmal!",
            date: "June 2020"
          }
        }
      },
      imprint: "imprint",
      datasecurityLink: "Data Privacy Statement"
    },
    picturesSource: {
      table: {
        mainPictures: [
          require('./../../public/img/tableInfoPictures/gerüstbohlen-möbel-tisch-01.jpeg'),
          require('./../../public/img/tableInfoPictures/gerüstbohlen-möbel-tisch-02.jpeg'),
          require('./../../public/img/tableInfoPictures/gerüstbohlen-möbel-tisch-03.jpeg'),
          require('./../../public/img/tableInfoPictures/gerüstbohlen-möbel-tisch-04.jpeg'),
          require('./../../public/img/tableInfoPictures/gerüstbohlen-möbel-tisch-05.jpeg'),
          require('./../../public/img/tableInfoPictures/gerüstbohlen-möbel-tisch-06.jpeg'),
          require('./../../public/img/tableInfoPictures/gerüstbohlen-möbel-tisch-07.jpeg'),
          require('./../../public/img/tableInfoPictures/gerüstbohlen-möbel-tisch-08.jpeg'),
          require('./../../public/img/tableInfoPictures/gerüstbohlen-möbel-tisch-09.jpeg'),
          require('./../../public/img/tableInfoPictures/gerüstbohlen-möbel-tisch-10.jpeg'),
          require('./../../public/img/tableInfoPictures/gerüstbohlen-möbel-tisch-11.jpeg'),
          require('./../../public/img/tableInfoPictures/gerüstbohlen-möbel-tisch-12.jpeg'),
          require('./../../public/img/tableInfoPictures/gerüstbohlen-möbel-tisch-13.jpeg'),
          require('./../../public/img/tableInfoPictures/gerüstbohlen-möbel-tisch-14.jpeg'),
          require('./../../public/img/tableInfoPictures/gerüstbohlen-möbel-tisch-15.jpeg'),
          require('./../../public/img/tableInfoPictures/gerüstbohlen-möbel-tisch-16.jpeg')
        ]
      },
      tableOffice: {
        mainPictures: [
          require('./../../public/img/tableOfficeInfoPictures/gerüstbohlen-möbel-schreibtisch-01.jpeg'),
          require('./../../public/img/tableOfficeInfoPictures/gerüstbohlen-möbel-schreibtisch-02.jpeg'),
          require('./../../public/img/tableOfficeInfoPictures/gerüstbohlen-möbel-schreibtisch-03.jpeg'),
          require('./../../public/img/tableOfficeInfoPictures/gerüstbohlen-möbel-schreibtisch-04.jpeg'),
          require('./../../public/img/tableOfficeInfoPictures/gerüstbohlen-möbel-schreibtisch-05.jpeg')
        ]
      },
      shelf: {
        mainPictures: [
        require('./../../public/img/shelfInfoPictures/gerüstbohlen-möbel-regal-01.jpeg'),
        require('./../../public/img/shelfInfoPictures/gerüstbohlen-möbel-regal-02.jpeg'),
        require('./../../public/img/shelfInfoPictures/gerüstbohlen-möbel-regal-03.jpeg'),
        require('./../../public/img/shelfInfoPictures/gerüstbohlen-möbel-regal-04.jpeg'),
        require('./../../public/img/shelfInfoPictures/gerüstbohlen-möbel-regal-05.jpeg'),
        require('./../../public/img/shelfInfoPictures/gerüstbohlen-möbel-regal-06.jpeg'),
        require('./../../public/img/shelfInfoPictures/gerüstbohlen-möbel-regal-07.jpeg'),
        require('./../../public/img/shelfInfoPictures/gerüstbohlen-möbel-regal-08.jpeg')
        ]
      },
      bench: {
        mainPictures: [
          require('./../../public/img/benchInfoPictures/gerüstbohlen-möbel-bank-01.jpeg'),
          require('./../../public/img/benchInfoPictures/gerüstbohlen-möbel-bank-02.jpeg'),
          require('./../../public/img/benchInfoPictures/gerüstbohlen-möbel-bank-03.jpeg'),
          require('./../../public/img/benchInfoPictures/gerüstbohlen-möbel-bank-04.jpeg'),
          require('./../../public/img/benchInfoPictures/gerüstbohlen-möbel-bank-05.jpeg'),
          require('./../../public/img/benchInfoPictures/gerüstbohlen-möbel-bank-06.jpeg'),
          require('./../../public/img/benchInfoPictures/gerüstbohlen-möbel-bank-07.jpeg'),
          require('./../../public/img/benchInfoPictures/gerüstbohlen-möbel-bank-08.jpeg'),
          require('./../../public/img/benchInfoPictures/gerüstbohlen-möbel-bank-09.jpeg')
        ]
      },
      frame: {
        mainPictures: [
          require('./../../public/img/frameInfoPictures/gerüstbohlen-möbel-rahmen-01.jpeg'),
          require('./../../public/img/frameInfoPictures/gerüstbohlen-möbel-rahmen-02.jpeg'),
          require('./../../public/img/frameInfoPictures/gerüstbohlen-möbel-rahmen-03.jpeg'),
        ]
      },
      stool: {
        mainPictures: [
          require('./../../public/img/stoolInfoPictures/gerüstbohlen-möbel-hocker-01.jpeg'),
          require('./../../public/img/stoolInfoPictures/gerüstbohlen-möbel-hocker-02.jpeg'),
          require('./../../public/img/stoolInfoPictures/gerüstbohlen-möbel-hocker-03.jpeg'),
          require('./../../public/img/stoolInfoPictures/gerüstbohlen-möbel-hocker-04.jpeg'),
          require('./../../public/img/stoolInfoPictures/gerüstbohlen-möbel-hocker-05.jpeg'),
          require('./../../public/img/stoolInfoPictures/gerüstbohlen-möbel-hocker-06.jpeg'),
          require('./../../public/img/stoolInfoPictures/gerüstbohlen-möbel-hocker-07.jpeg'),
          require('./../../public/img/stoolInfoPictures/gerüstbohlen-möbel-hocker-08.jpeg')
        ]
      },
    },
    reviews: {
      table: [
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-christoph.jpeg"),
          name: "Christoph",
          length: 220,
          width: 110,
          height: 75,
          id: 45
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-gina.jpeg"),
          name: "Gina",
          length: 180,
          width: 100,
          height: 75,
          id: 44
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-alexander.jpeg"),
          name: "Alexander",
          length: 220,
          width: 95,
          height: 75,
          id: 43
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-konstantin.jpeg"),
          name: "Konstantin",
          length: 150,
          width: 82,
          height: 75,
          id: 42
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-kathrin.jpeg"),
          name: "Kathrin",
          length: 150,
          width: 95,
          height: 75,
          id: 41
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-felix.jpeg"),
          name: "Felix",
          length: 220,
          width: 110,
          height: 75,
          id: 40
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-marie-sophie.jpeg"),
          name: "Marie-Sophie",
          length: 200,
          width: 90,
          height: 75,
          id: 39
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-matthias.jpeg"),
          name: "Matthias",
          length: 220,
          width: 110,
          height: 75,
          id: 38
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-christina.jpeg"),
          name: "Christina",
          length: 200,
          width: 82,
          height: 75,
          id: 37
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-thorben.jpeg"),
          name: "Thorben",
          length: 220,
          width: 110,
          height: 75,
          id: 36
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-sophia.jpeg"),
          name: "Sophia",
          length: 165,
          width: 90,
          height: 75,
          id: 35
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-bernd.jpeg"),
          name: "Bernd",
          length: 190,
          width: 82,
          height: 75,
          id: 34
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-kerstin.jpeg"),
          name: "Kerstin",
          length: 160,
          width: 82,
          height: 75,
          id: 33
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-lena2.jpeg"),
          name: "Lena",
          length: 160,
          width: 90,
          height: 75,
          id: 32
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-sven.jpeg"),
          name: "Sven",
          length: 200,
          width: 110,
          height: 75,
          id: 31
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-hanna.jpeg"),
          name: "Hanna",
          length: 160,
          width: 80,
          height: 75,
          id: 30
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-anja.jpeg"),
          name: "Anja",
          length: 200,
          width: 82,
          height: 75,
          id: 29
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-thomas2.jpeg"),
          name: "Thomas",
          length: 150,
          width: 90,
          height: 75,
          id: 28
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-claudia.jpeg"),
          name: "Claudia",
          length: 200,
          width: 100,
          height: 75,
          id: 27
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-hannah.jpeg"),
          name: "Hannah",
          length: 250,
          width: 110,
          height: 75,
          id: 26
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-patrick.jpeg"),
          name: "Patrick",
          length: 250,
          width: 82,
          height: 75,
          id: 25
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-juliane.jpeg"),
          name: "Juliane",
          length: 170,
          width: 75,
          height: 75,
          id: 24
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-sandra.jpeg"),
          name: "Sandra",
          length: 170,
          width: 75,
          height: 75,
          id: 23
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-caro.jpeg"),
          name: "Caro",
          length: 220,
          width: 82,
          height: 76,
          id: 22
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-thomas.jpeg"),
          name: "Thomas",
          length: 200,
          width: 82,
          height: 76,
          id: 21
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-sabrina.jpeg"),
          name: "Sabrina",
          length: 220,
          width: 110,
          height: 76,
          id: 20
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-nele.jpeg"),
          name: "Nele",
          length: 165,
          width: 82,
          height: 75,
          id: 19
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-lena.jpeg"),
          name: "Lena",
          length: 210,
          width: 82,
          height: 75,
          id: 18
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-alia.jpeg"),
          name: "Alia",
          length: 180,
          width: 82,
          height: 75,
          id: 17
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-mareike.jpeg"),
          name: "Mareike",
          length: 190,
          width: 80,
          height: 77,
          id: 16
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-daniel.jpeg"),
          name: "Daniel",
          length: 160,
          width: 82,
          height: 975,
          id: 15
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-christian.jpeg"),
          name: "Christian",
          length: 200,
          width: 90,
          height: 75,
          id: 14
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-julia.jpeg"),
          name: "Julia",
          length: 170,
          width: 80,
          height: 75,
          id: 13
        },
        // {
        //   img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-nadine.jpg"),
        //   name: "Nadine",
        //   length: 160,
        //   width: 80,
        //   height: 77,
        //   id: 12
        // },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-suzanne.jpg"),
          name: "Suzanne",
          length: 220,
          width: 82,
          height: 75,
          id: 11
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-uli.jpg"),
          name: "Uli",
          length: 180,
          width: 70,
          height: 75,
          id: 10
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-nicolas.jpg"),
          name: "Nicolas",
          length: 220,
          width: 82,
          height: 75,
          id: 9
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-nadine.jpeg"),
          name: "Nadine",
          length: 160,
          width: 80,
          height: 77,
          id: 8
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-carolin.jpg"),
          name: "Carolin",
          length: 220,
          width: 100,
          height: 75,
          id: 7
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-lukas.jpg"),
          name: "Lukas",
          length: 200,
          width: 82,
          height: 75,
          id: 6
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-franzi.jpg"),
          name: "Franzi",
          length: 160,
          width: 800,
          height: 75,
          id: 5
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-jenny.jpg"),
          name: "Jenny",
          length: 200,
          width: 110,
          height: 75,
          id: 4
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-nicole.jpg"),
          name: "Nicole",
          length: 200,
          width: 80,
          height: 75,
          id: 3
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-lisa.jpg"),
          name: "Lisa",
          length: 175,
          width: 82,
          height: 75,
          id: 2
        },
        {
          img: require("./../../public/img/tableInfoPictures/reviews/gerüstbohlen-möbel-tisch-sybilla.jpg"),
          name: "Sybilla",
          length: 210,
          width: 82,
          height: 75,
          id: 1
        },
      ],
      bench: [
        {
          img: require("./../../public/img/benchInfoPictures/reviews/gerüstbohlen-möbel-bank-anja.jpeg"),
          name: "Anja",
          length: 200,
          width: 40,
          height: 45,
          id: 5
        },
        {
          img: require("./../../public/img/benchInfoPictures/reviews/gerüstbohlen-möbel-bank-juliane.jpeg"),
          name: "Juliane",
          length: 170,
          width: 40,
          height: 45,
          id: 4
        },
        {
          img: require("./../../public/img/benchInfoPictures/reviews/gerüstbohlen-möbel-bank-christian.jpeg"),
          name: "Christian",
          length: 200,
          width: 40,
          height: 45,
          id: 3
        },
        {
          img: require("./../../public/img/benchInfoPictures/reviews/gerüstbohlen-möbel-bank-lukas.jpg"),
          name: "Lukas",
          length: 130,
          width: 40,
          height: 45,
          id: 2
        },
        {
          img: require("./../../public/img/benchInfoPictures/reviews/gerüstbohlen-möbel-bank-anna-lena.jpg"),
          name: "Anna-Lena",
          length: 150,
          width: 40,
          height: 45,
          id: 1
        }
      ],
      stool: [
      ]
    }
  },
  mutations: {
    FOOTER(state, footer){
      state.footer = footer
    },
    SET_ANIMATION_PROPERTIES(state, input){
      switch (input){
        case 'mobile':
          state.animationProperties.mobile = true;
          state.animationProperties.radius = state.animationProperties.defaults.mobile.radius;
          state.animationProperties.beta = state.animationProperties.defaults.mobile.beta;
          state.animationProperties.alpha = state.animationProperties.defaults.mobile.alpha;
        break;
        case 'dekstop':
          state.animationProperties.mobile = false;
          state.animationProperties.radius = state.animationProperties.defaults.desktop.radius;
          state.animationProperties.beta = state.animationProperties.defaults.desktop.beta;
          state.animationProperties.alpha = state.animationProperties.defaults.desktop.alpha;
        break;
        default:
        break;
      }
      if(input.change == 'verticalOrientation'){
        state.animationProperties.vertical = input.value
      }
    },
    SET_NAVBAR_ACTIVE(state, index){
      state.navbarActive = [false, false, false, false, false, false, false]
      state.navbarActive[index] = true
    },
    CHANGE_CUSTOMER_INFORMATION(state, customerInformation){
      state.order.date = new Date().toLocaleString()
      state.order.customer = customerInformation
      state.order.customer.ID = state.order.orderID
    },
    CALCULATE_TOTAL_PRICE(state){
      var arrayLength = state.order.products.length;
      state.order.totalPrice = 0
      for (var i = 0; i < arrayLength; i++) {
        if(state.order.products[i].discount){
          state.order.totalPrice += parseInt(state.order.products[i].discountPrice)
        } else {
          state.order.totalPrice += parseInt(state.order.products[i].price)
        }
      }

      if(state.order.totalPrice < state.shippingAndDiscount.shippingCostLowThreshhold){
        state.shippingAndDiscount.shippingCost = state.shippingAndDiscount.shippingCostLow
      } else if (state.order.totalPrice < state.shippingAndDiscount.shippingCostMediumThreshhold){
        state.shippingAndDiscount.shippingCost = state.shippingAndDiscount.shippingCostMedium
      } else {
        state.shippingAndDiscount.shippingCost = state.shippingAndDiscount.shippingCostNormal
      }

      if(!state.order.customer.shipping){
        state.order.totalPrice -= state.shippingAndDiscount.shippingCost
      }

      if(state.order.customer.expressBuild=="expressBuildYes"){
        state.order.totalPrice += 65
      }

      state.order.totalPrice -= state.order.customer.voucherSum

      state.order.paypalPriceString = Math.round(state.order.totalPrice).toString()
    },
    APPLY_VOUCHER(state){
      for (var voucher in state.voucher.vouchers) {
        if(state.voucher.vouchers[voucher].code == state.order.customer.voucher){
          if(!state.voucher.vouchers[voucher].used){
            state.order.customer.voucherSum = state.voucher.vouchers[voucher].value
            state.voucher.vouchers[voucher].used = true
            state.voucher.voucherAccepted = true
          }
        }
      }
    },
    DELETE_FROM_CART(state, index){
      state.order.products.splice(index, 1)
    },
    ADD_TO_CART(state, type){
      var payload = {
        product:type,
        name:'',
        discount: false,
        discountPrice:0,
        discountAmount:0,
        frameName:'',
        price:0,
        length:0,
        width:0,
        height:0,
        frame:'',
        chooseColor:false,
        color:'',
        colorName: '',
        frameFilling: '',
        choosePlanks:true,
        plank1:-1,
        plank2:-1,
        plank3:-1,
        plank4:-1,
        planks: [],
        plankInfo: [],
        numberOfPlanks:0,
        numberOfPillars: NaN,
        distanceLeftToMiddle: NaN,
        tableTop: '',
      }
      switch(type){
        case 'table':
          payload.name= "Tisch"
          payload.price= state.tableConfig.price
          payload.length= state.tableConfig.dimensions.length
          payload.width= state.tableConfig.dimensions.width
          payload.height= state.tableConfig.dimensions.height
          payload.frame= state.tableConfig.frameType
          payload.color= state.tableConfig.color.hex
          payload.colorName= state.tableConfig.color.name
          payload.chooseColor= state.tableConfig.color.chooseOwnColor
          payload.choosePlanks= state.tableConfig.planks.choosePlanks
          payload.tableTop= state.tableConfig.tableTop
          payload.plank1= state.tableConfig.planks.availablePlanks[state.tableConfig.planks.used[0].index]
          payload.plank2= state.tableConfig.planks.availablePlanks[state.tableConfig.planks.used[1].index]
          if(state.tableConfig.planks.numberOfPlanks >= 3){
             payload.plank3= state.tableConfig.planks.availablePlanks[state.tableConfig.planks.used[2].index]
             if(state.tableConfig.planks.numberOfPlanks >= 4){
               payload.plank4= state.tableConfig.planks.availablePlanks[state.tableConfig.planks.used[3].index]
             }
          }
          payload.numberOfPlanks= state.tableConfig.planks.numberOfPlanks
          switch(state.tableConfig.frameType){
            case 'open':
              payload.frameName = "offen"
            break
            case 'closed':
              payload.frameName = "geschlossen"
            break
            case 'diagonal':
              payload.frameName = "diagonal"
            break
            default:
            break
          }
        break
        case 'tableOffice':
          payload.name= "Schreibtisch"
          payload.price= state.tableOfficeConfig.price
          payload.length= state.tableOfficeConfig.dimensions.length
          payload.width= state.tableOfficeConfig.dimensions.width
          payload.height= state.tableOfficeConfig.dimensions.height
          payload.color= state.tableOfficeConfig.color.hex
          payload.colorName= state.tableOfficeConfig.color.name
          payload.plank1= state.tableOfficeConfig.planks.availablePlanks[state.tableOfficeConfig.planks.used[0].index]
        break
        case 'shelf':
          payload.name= "Regal"
          payload.price= state.shelfConfig.price
          payload.length= state.shelfConfig.dimensions.length
          payload.width= state.shelfConfig.dimensions.width
          payload.height= state.shelfConfig.dimensions.height
          payload.color= state.shelfConfig.color.hex
          payload.colorName= state.shelfConfig.color.name
          payload.chooseColor= state.shelfConfig.color.chooseOwnColor
          payload.numberOfPillars = state.shelfConfig.dimensions.numberOfPillows
          payload.distanceLeftToMiddle = state.shelfConfig.dimensions.distanceLeftMiddle
          payload.numberOfPlanks= state.shelfConfig.planks.active.numberOfPlanks
          for(var i = 0; i < state.shelfConfig.planks.active.planks.length; i++){
            payload.planks.push(
              state.shelfConfig.planks.availablePlanks[state.shelfConfig.planks.active.planks[i].index]
            )
          }
          payload.plankInfo = state.shelfConfig.planks.active.planks
        break
        case 'bench':
          payload.name= "Bank"
          payload.price= state.benchConfig.price
          payload.length= state.benchConfig.dimensions.length
          payload.width= state.benchConfig.dimensions.width
          payload.height= state.benchConfig.dimensions.height
          payload.frame= state.benchConfig.frameType
          payload.chooseColor= state.benchConfig.color.chooseOwnColor
          payload.color= state.benchConfig.color.hex
          payload.colorName= state.benchConfig.color.name
          payload.choosePlanks= state.benchConfig.planks.choosePlanks
          payload.plank1= state.benchConfig.planks.availablePlanks[state.benchConfig.planks.used[0].index]
          switch(state.benchConfig.frameType){
            case 'simple':
              payload.frameName = "einfach"
            break
            case 'massive':
              payload.frameName = "massiv"
            break
            default:
            break
          }
        break
        case 'stool':
          payload.name= "Hocker"
          payload.price= state.stoolConfig.price
          payload.length= state.stoolConfig.dimensions.length
          payload.width= state.stoolConfig.dimensions.width
          payload.height= state.stoolConfig.dimensions.height
          payload.frame= state.stoolConfig.frameType
          payload.chooseColor= state.stoolConfig.color.chooseOwnColor
          payload.color= state.stoolConfig.color.hex
          payload.colorName= state.stoolConfig.color.name
          payload.choosePlanks= state.stoolConfig.planks.choosePlanks
          payload.plank1= state.stoolConfig.planks.availablePlanks[state.stoolConfig.planks.used[0].index]
          switch(state.stoolConfig.frameType){
            case 'simple':
              payload.frameName = "einfach"
            break
            case 'massive':
              payload.frameName = "massiv"
            break
            default:
            break
          }
        break
        case 'frame':
          payload.name= "Rahmen"
          payload.price= state.frameConfig.price
          payload.width= state.frameConfig.dimensions.width
          payload.height= state.frameConfig.dimensions.height
          payload.frameFilling = state.frameConfig.filling.type
        break
        case 'sample':
          payload.name= "Muster"
          payload.price= state.sample.price
        break
        default:
        break
      }
      state.order.products.push(payload)

      ecommerce.addItem({
         id: state.order.orderID,
         name: payload.name,
         price: payload.price,
       })
    },
    CALCULATE_DISCOUNT(state){
      var prices = []
      for(var i = 0;i < state.order.products.length; i++){
        prices.push(state.order.products[i].price)
      }
      var highestPrice = Math.max.apply(Math, prices)
      for(var j = 0;j < state.order.products.length; j++){
        if(state.order.products[j].price == highestPrice){
          state.order.products[j].discount = false
        } else {
          state.order.products[j].discount = true
          var discountPrice = (1 - state.shippingAndDiscount.discountOnMultipleItems) * state.order.products[j].price
          state.order.products[j].discountPrice = Math.round(discountPrice)
          state.order.products[j].discountAmount = state.order.products[j].price - state.order.products[j].discountPrice
        }
      }
    },
    SET_ORDERID(state, orderID){
      state.order.orderID = orderID
    },
    SET_STRIPE_ID(state, stripeID){
      state.order.stripeID = stripeID
    },
    SET_STRIPE_ORDER(state, order){
      state.order = order
    },

    STOOL_CONFIG_HEIGHT(state, height){
      state.stoolConfig.dimensions.height = height
    },
    STOOL_PRICE(state, price){
      state.stoolConfig.price = price
    },
    STOOL_CONFIG_FRAME(state, frameType){
      state.stoolConfig.frameType = frameType
    },
    STOOL_CONFIG_COLOR_TYPE(state, type){
      state.stoolConfig.color.appearance = type
    },
    STOOL_CONFIG_COLOR(state, hex){
      state.stoolConfig.color.hex = hex
      switch(hex){
        case '#383430':
          state.stoolConfig.color.name = "Klarlack"
        break;
        case "#FFFFFF":
          state.stoolConfig.color.name = "Weiss"
        break;
        case "#27292B":
          state.stoolConfig.color.name = "Graphit"
        break;
        default:
          state.stoolConfig.color.name = ""
        break;
      }
    },
    STOOL_CONFIG_DIMENSION_TYPE(state, value){
      state.stoolConfig.dimensions.chosen = value
    },
    STOOL_CONFIG_CHOOSE_PLANKS(state, choosePlanks){
      state.stoolConfig.planks.choosePlanks = choosePlanks
    },
    STOOL_CONFIG_CHOOSE_COLOR(state, chooseColor){
      state.stoolConfig.color.chooseOwnColor = chooseColor
    },
    STOOL_ADD_AVAILABLE_PLANK(state, plank){
      state.stoolConfig.planks.availablePlanks.push(plank.name)
      state.stoolConfig.planks.availablePlanksTitle.push(plank.title)
    },
    STOOL_CLEAR_AVAILABLE_PLANKS(state){
      state.stoolConfig.planks.availablePlanks = []
      state.stoolConfig.planks.availablePlanksTitle = []
    },
    STOOL_SET_PLANK(state, payload){
      state.stoolConfig.planks.used[payload.plank].index = payload.index
    },
    STOOL_SET_PLANK_UP(state, payload){
      state.stoolConfig.planks.used[payload.plank].upArrow = payload.upArrow
    },
    STOOL_SET_PLANK_DOWN(state, payload){
      state.stoolConfig.planks.used[payload.plank].downArrow = payload.downArrow
    },

    BENCH_CONFIG_LENGTH(state, length){
      state.benchConfig.dimensions.length = length
    },
    BENCH_PRICE(state, price){
      state.benchConfig.price = price
    },
    BENCH_CONFIG_FRAME(state, frameType){
      state.benchConfig.frameType = frameType
    },
    BENCH_CONFIG_COLOR_TYPE(state, type){
      state.benchConfig.color.appearance = type
    },
    BENCH_CONFIG_COLOR(state, hex){
      state.benchConfig.color.hex = hex
      switch(hex){
        case '#383430':
          state.benchConfig.color.name = "Klarlack"
        break;
        case "#FFFFFF":
          state.benchConfig.color.name = "Weiss"
        break;
        case "#27292B":
          state.benchConfig.color.name = "Graphit"
        break;
        default:
          state.benchConfig.color.name = ""
        break;
      }
    },
    BENCH_CONFIG_CHOOSE_PLANKS(state, choosePlanks){
      state.benchConfig.planks.choosePlanks = choosePlanks
    },
    BENCH_CONFIG_CHOOSE_COLOR(state, chooseColor){
      state.benchConfig.color.chooseOwnColor = chooseColor
    },
    BENCH_CLEAR_AVAILABLE_PLANKS(state){
      state.benchConfig.planks.availablePlanks = []
      state.benchConfig.planks.availablePlanksTitle = []
    },
    BENCH_ADD_AVAILABLE_PLANK(state, plank){
      state.benchConfig.planks.availablePlanks.push(plank.name)
      state.benchConfig.planks.availablePlanksTitle.push(plank.title)
    },
    BENCH_SET_PLANK(state, payload){
      state.benchConfig.planks.used[payload.plank].index = payload.index
    },
    BENCH_CONFIG_DIMENSION_TYPE(state, value){
      state.benchConfig.dimensions.chosen = value
    },
    BENCH_SET_PLANK_UP(state, payload){
      state.benchConfig.planks.used[payload.plank].upArrow = payload.upArrow
    },
    BENCH_SET_PLANK_DOWN(state, payload){
      state.benchConfig.planks.used[payload.plank].downArrow = payload.downArrow
    },

    FRAME_CONFIG_WIDTH(state, width){
      state.frameConfig.dimensions.width = width
    },
    FRAME_CONFIG_HEIGHT(state, height){
      state.frameConfig.dimensions.height = height
    },
    FRAME_PRICE(state, price){
      state.frameConfig.price = price
    },
    FRAME_CONFIG_FILLING(state, filling){
      state.frameConfig.filling.type = filling
    },
    FRAME_CONFIG_PASSEPARTOUT_COLOR(state, color){
      console.log(color)
      state.frameConfig.filling.passepartout.color = color
    },

    TABLE_CONFIG_LENGTH(state, length){
      state.tableConfig.dimensions.length = length
    },
    TABLE_CONFIG_WIDTH(state, width){
      state.tableConfig.dimensions.width = width
    },
    TABLE_CONFIG_HEIGHT(state, height){
      state.tableConfig.dimensions.height = height
    },
    TABLE_CONFIG_DIMENSION_TYPE(state, value){
      state.tableConfig.dimensions.chosen = value
    },
    TABLE_PRICE(state, price){
      state.tableConfig.price = price
    },
    TABLE_CONFIG_FRAME(state, frameType){
      state.tableConfig.frameType = frameType
    },
    TABLE_CONFIG_TABLE_TOP(state, tableTop){
      state.tableConfig.tableTop = tableTop
    },
    TABLE_CONFIG_COLOR_TYPE(state, type){
      state.tableConfig.color.appearance = type
    },
    TABLE_CONFIG_COLOR(state, hex){
      state.tableConfig.color.hex = hex
      switch(hex){
        case '#383430':
          state.tableConfig.color.name = "Klarlack"
        break;
        case "#FFFFFF":
          state.tableConfig.color.name = "Weiss"
        break;
        case "#27292B":
          state.tableConfig.color.name = "Graphit"
        break;
        default:
          state.tableConfig.color.name = ""
        break;
      }
    },
    TABLE_CONFIG_CHOOSE_PLANKS(state, choosePlanks){
      state.tableConfig.planks.choosePlanks = choosePlanks
    },
    TABLE_CONFIG_CHOOSE_COLOR(state, chooseColor){
      state.tableConfig.color.chooseOwnColor = chooseColor
    },
    TABLE_CONFIG_ACTIVE_PLANKS(state, activePlanks){
      for(var i=0; i < activePlanks.active.length; i++){
        state.tableConfig.planks.used[i].active = activePlanks.active[i]
        state.tableConfig.planks.numberOfPlanks = activePlanks.numberOfPlanks
      }
    },
    TABLE_CLEAR_AVAILABLE_PLANKS(state){
      state.tableConfig.planks.availablePlanks = []
      state.tableConfig.planks.availablePlanksTitle = []
    },
    TABLE_ADD_AVAILABLE_PLANK(state, plank){
      state.tableConfig.planks.availablePlanks.push(plank.name)
      state.tableConfig.planks.availablePlanksTitle.push(plank.title)
    },
    TABLE_SET_PLANK(state, payload){
      state.tableConfig.planks.used[payload.plank].index = payload.index
    },
    TABLE_SET_PLANK_UP(state, payload){
      state.tableConfig.planks.used[payload.plank].upArrow = payload.upArrow
    },
    TABLE_SET_PLANK_DOWN(state, payload){
      state.tableConfig.planks.used[payload.plank].downArrow = payload.downArrow
    },
    SET_LANGUAGE(state, language){
      state.language = language
    },

    TABLE_OFFICE_PRICE(state, price){
      state.tableOfficeConfig.price = price
    },
    TABLE_OFFICE_CONFIG_COLOR(state, hex){
      state.tableOfficeConfig.color.hex = hex
    },
    TABLE_OFFICE_SET_PLANK(state, payload){
      state.tableOfficeConfig.planks.used[payload.plank].index = payload.index
      console.log()
    },
    TABLE_OFFICE_SET_PLANK_UP(state, payload){
      state.tableOfficeConfig.planks.used[payload.plank].upArrow = payload.upArrow
    },
    TABLE_OFFICE_SET_PLANK_DOWN(state, payload){
      state.tableOfficeConfig.planks.used[payload.plank].downArrow = payload.downArrow
    },
    TABLE_OFFICE_CLEAR_AVAILABLE_PLANKS(state){
      state.tableOfficeConfig.planks.availablePlanks = []
      state.tableOfficeConfig.planks.availablePlanksTitle = []
    },
    TABLE_OFFICE_ADD_AVAILABLE_PLANK(state, plank){
      state.tableOfficeConfig.planks.availablePlanks.push(plank.name)
      state.tableOfficeConfig.planks.availablePlanksTitle.push(plank.title)
      console.log(state.tableOfficeConfig.planks.availablePlanks)
    },

    SHELF_CONFIG_HEIGHT(state, height){
      state.shelfConfig.dimensions.height = height
    },
    SHELF_CONFIG_WIDTH(state, width){
      state.shelfConfig.dimensions.width = width
    },
    SHELF_CONFIG_NUMBER_OF_PILLOWS(state, numberOfPillows){
      state.shelfConfig.dimensions.numberOfPillows = numberOfPillows
    },
    SHELF_CONFIG_DISTANCE_LEFT_MIDDLE(state, distanceLeftMiddle){
      state.shelfConfig.dimensions.distanceLeftMiddle = distanceLeftMiddle
    },
    SHELF_CONFIG_NUMBER_OF_PLANKS(state, numberOfPlanks){
      state.shelfConfig.planks.numberOfPlanks = numberOfPlanks
    },
    SHELF_CONFIG_DISTANCE_TOP_TO_FIRST_PLANK(state, distanceTopToFirstPlank){
      state.shelfConfig.dimensions.distanceTopToFirstPlank = distanceTopToFirstPlank
    },
    SHELF_CLEAR_AVAILABLE_PLANKS(state){
      state.shelfConfig.planks.availablePlanks = []
      state.shelfConfig.planks.availablePlanksTitle = []
    },
    SHELF_ADD_AVAILABLE_PLANK(state, plank){
      state.shelfConfig.planks.availablePlanks.push(plank.name)
      state.shelfConfig.planks.availablePlanksTitle.push(plank.title)
    },
    SHELF_SET_PLANK_UP(state, payload){
      state.shelfConfig.planks.active.planks[payload.plank].upArrow = payload.upArrow
    },
    SHELF_SET_PLANK_DOWN(state, payload){
      state.shelfConfig.planks.active.planks[payload.plank].downArrow = payload.downArrow
    },

    SHELF_CONFIG_CHOOSE_COLOR(state, chooseColor){
      state.shelfConfig.color.chooseOwnColor = chooseColor
    },
    SHELF_CONFIG_COLOR(state, color){
      state.shelfConfig.color.hex = color
      switch(color){
        case '#383430':
          state.shelfConfig.color.name = "Klarlack"
        break;
        case "#FFFFFF":
          state.shelfConfig.color.name = "Weiss"
        break;
        case "#27292B":
          state.shelfConfig.color.name = "Graphit"
        break;
        default:
          state.shelfConfig.color.name = ""
        break;
      }
    },
    SHELF_CLEAR_ACTIVE_PLANKS(state){
      state.shelfConfig.planks.active.planks = []
    },
    SHELF_SET_NUMBER_OF_ACTIVE_PLANKS(state, number){
      switch (number){
        case '+':
          state.shelfConfig.planks.active.numberOfPlanks += 1
        break;
        case '-':
          state.shelfConfig.planks.active.numberOfPlanks -= 1
        break;
        default:
          state.shelfConfig.planks.active.numberOfPlanks = number
        break;
      }
    },
    SHELF_ADD_ACTIVE_PLANK(state){
      state.shelfConfig.planks.active.planks.push({
        distanceFromTop:20,
        distanceToBelow:20,
        leftShort:false,
        rightShort:false,
        index: NaN,
        downArrow: false,
        upArrow: false,
        width: NaN,
        name: "",
        title: ""
      })
    },
    SHELF_SUBTRACT_ACTIVE_PLANK(state){
      state.shelfConfig.planks.active.planks.pop()
    },
    SHELF_UPDATE_ACTIVE_PLANKS(state, planks){
      state.shelfConfig.planks.used = planks
    },
    SHELF_SET_ACTIVE_PLANK(state, payload){
      state.shelfConfig.planks.active.planks[payload.plank].index = payload.index
      state.shelfConfig.planks.active.planks[payload.plank].name = state.shelfConfig.planks.availablePlanksTitle[payload.index]
      // state.shelfConfig.planks.active.planks[index].upArrow = true
      // state.shelfConfig.planks.active.planks[index].downArrow = true
      if (state.shelfConfig.planks.active.planks[payload.plank].leftShort){
        state.shelfConfig.planks.active.planks[payload.plank].width = state.shelfConfig.dimensions.width - state.shelfConfig.dimensions.pillowWidth - state.shelfConfig.dimensions.distanceLeftMiddle
      } else if (state.shelfConfig.planks.active.planks[payload.plank].rightShort){
        var distanceRightToMiddle = state.shelfConfig.dimensions.width - 3 * state.shelfConfig.dimensions.pillowWidth - 2 * state.shelfConfig.dimensions.distanceOutsideToPillow - state.shelfConfig.dimensions.distanceLeftMiddle
        state.shelfConfig.planks.active.planks[payload.plank].width = state.shelfConfig.dimensions.width - state.shelfConfig.dimensions.pillowWidth - distanceRightToMiddle
      } else {
        state.shelfConfig.planks.active.planks[payload.plank].width = state.shelfConfig.dimensions.width
      }
    },
    SHELF_DELETE_ACTIVE_PLANK_NAME(state, index){
      state.shelfConfig.planks.active.planks[index].index = NaN
      state.shelfConfig.planks.active.planks[index].name = ""
      state.shelfConfig.planks.active.planks[index].title = ""
    },
    SHELF_SET_PLANK(state, payload){
      state.shelfConfig.planks.active.planks[payload.plank].index = payload.index
    },
    SHELF_PRICE(state, price){
      state.shelfConfig.price = price
    },
    SHELF_SET_EVEN_SPACE_BETWEEN_PLANKS(state) {
      var height = state.shelfConfig.dimensions.height
      var topToFirst = state.shelfConfig.dimensions.distanceTopToFirstPlank
      var numberOfPlanks = state.shelfConfig.planks.active.numberOfPlanks
      var plankThikness = state.shelfConfig.dimensions.plankThikness
      var evenSpaceBetweenPlanks = (height - topToFirst - numberOfPlanks * plankThikness) / numberOfPlanks

      for (var i = 0; i < numberOfPlanks; i++){
        state.shelfConfig.planks.active.planks[i].distanceToBelow = evenSpaceBetweenPlanks
      }
    },
  },
  actions: {
    showFooter(context, footer){
      context.commit("FOOTER", footer)
    },
    setAnimationProperties(context, mobile){
      context.commit("SET_ANIMATION_PROPERTIES", mobile)
    },
    applyVoucher(context){
      context.commit("APPLY_VOUCHER")
      context.commit("CALCULATE_TOTAL_PRICE")

    },
    getStripeID(context){
      var stripeID = ''

      // axios.get('https://us-central1-furnitures-7a3b4.cloudfunctions.net/checkoutSession', {
      //    params: context.state.order
      //  })
      //  .then(response => {
      //    stripeID = response.data
      //    console.log(response.data);
      //  })
      //  .catch(error => {
      //    console.log(error)
      //  });

       context.commit("SET_STRIPE_ID", stripeID)
    },
    setStripeOrder(context, order){
      context.commit("SET_STRIPE_ORDER", order),
      context.dispatch("buyingApproved")
    },
    buyingApproved(context){

      db.ref("customer").push(JSON.parse(JSON.stringify({
        customer: context.state.order.customer
      })))
      var productIndex = 0
      for(var order in context.state.order.products){
        var plank1 = ""
        var plank2 = ""
        var plank3 = ""
        var plank4 = ""
        if (context.state.order.products[order].plank1 != -1){
          plank1 = context.state.order.products[order].plank1.slice(0,2)
        }
        if (context.state.order.products[order].plank2 != -1){
          plank2 = context.state.order.products[order].plank2.slice(0,2)
        }
        if (context.state.order.products[order].plank3 != -1){
          plank3 = context.state.order.products[order].plank3.slice(0,2)
        }
        if (context.state.order.products[order].plank4 != -1){
          plank4 = context.state.order.products[order].plank4.slice(0,2)
        }
        db.ref("product").push(JSON.parse(JSON.stringify({
          product: context.state.order.products[order],
          message: context.state.order.customer.message,
          firstName: context.state.order.customer.firstName,
          lastName: context.state.order.customer.lastName,
          id: context.state.order.customer.ID + '.' + productIndex,
          plank1: plank1,
          plank2: plank2,
          plank3: plank3,
          plank4: plank4,
          length: context.state.order.products[order].length,
          width: context.state.order.products[order].width,
          productType: context.state.order.products[order].product,
        })))
        productIndex += 1
      }

      db.ref("order").push(JSON.parse(JSON.stringify({
        order : context.state.order
      }))).then(() => {
      for (var product in context.state.order.products) {
        if (context.state.order.products[product].choosePlanks){
          if(context.state.order.products[product].name == "Tisch"){
            let planksRef = db.ref("planks");
            let plank1 = context.state.order.products[product].plank1.substring(0, context.state.order.products[product].plank1.length - 5)
            planksRef.child(plank1).update({
              available: false,
              firstName: context.state.order.customer.firstName,
              lastName: context.state.order.customer.lastName
            })
            let plank2 = context.state.order.products[product].plank2.substring(0, context.state.order.products[product].plank2.length - 5)
            planksRef.child(plank2).update({
              available: false,
              firstName: context.state.order.customer.firstName,
              lastName: context.state.order.customer.lastName
            })
            if(context.state.order.products[product].numberOfPlanks > 2){
              let plank3 = context.state.order.products[product].plank3.substring(0, context.state.order.products[product].plank3.length - 5)
              planksRef.child(plank3).update({
                available: false,
                firstName: context.state.order.customer.firstName,
                lastName: context.state.order.customer.lastName
              })
            }
            if(context.state.order.products[product].numberOfPlanks > 3){
              let plank4 = context.state.order.products[product].plank4.substring(0, context.state.order.products[product].plank4.length - 5)
              planksRef.child(plank4).update({
                available: false,
                firstName: context.state.order.customer.firstName,
                lastName: context.state.order.customer.lastName
              })
            }
          } else if (context.state.order.products[product].name == "Schreibtisch"){
            let planksRef = db.ref("tableOfficePlanks");
            let plank1 = context.state.order.products[product].plank1.substring(0, context.state.order.products[product].plank1.length - 5)
            planksRef.child(plank1).update({
              available: false,
              firstName: context.state.order.customer.firstName,
              lastName: context.state.order.customer.lastName
            })
          } else if(context.state.order.products[product].name == "Regal"){
            let planksRef = db.ref("shelfPlanks");
            for (var i = 0; i < context.state.order.products[product].planks.length; i++){
              let plank = context.state.order.products[product].planks[i].substring(0, context.state.order.products[product].planks[i].length - 4)
              planksRef.child(plank).update({
                available: false,
                firstName: context.state.order.customer.firstName,
                lastName: context.state.order.customer.lastName
              })
            }

          } else if (context.state.order.products[product].name == "Bank"){
            let planksRef = db.ref("benchPlanks");
            let plank1 = context.state.order.products[product].plank1.substring(0, context.state.order.products[product].plank1.length - 4)
            planksRef.child(plank1).update({
              available: false,
              firstName: context.state.order.customer.firstName,
              lastName: context.state.order.customer.lastName
            })
          } else if (context.state.order.products[product].name == "Hocker"){
            let planksRef = db.ref("stoolPlanks");
            let plank1 = context.state.order.products[product].plank1.substring(0, context.state.order.products[product].plank1.length - 5)
            planksRef.child(plank1).update({
              available: false,
              firstName: context.state.order.customer.firstName,
              lastName: context.state.order.customer.lastName
            })
          }
        }
      }})
      context.dispatch("writeOrderID")
    },
    orderReserved(context){
      db.ref("reserved").push(JSON.parse(JSON.stringify({
        order : context.state.order
      }))).then(() => {
      for (var product in context.state.order.products) {
        if (context.state.order.products[product].choosePlanks){
          if(context.state.order.products[product].name == "Tisch"){
            let planksRef = db.ref("planks");
            let plank1 = context.state.order.products[product].plank1.substring(0, context.state.order.products[product].plank1.length - 5)
            planksRef.child(plank1).update({
              available: false,
              firstName: context.state.order.customer.firstName,
              lastName: context.state.order.customer.lastName
            })
            let plank2 = context.state.order.products[product].plank2.substring(0, context.state.order.products[product].plank2.length - 5)
            planksRef.child(plank2).update({
              available: false,
              firstName: context.state.order.customer.firstName,
              lastName: context.state.order.customer.lastName
            })
            if(context.state.order.products[product].numberOfPlanks > 2){
              let plank3 = context.state.order.products[product].plank3.substring(0, context.state.order.products[product].plank3.length - 5)
              planksRef.child(plank3).update({
                available: false,
                firstName: context.state.order.customer.firstName,
                lastName: context.state.order.customer.lastName
              })
            }
            if(context.state.order.products[product].numberOfPlanks > 3){
              let plank4 = context.state.order.products[product].plank4.substring(0, context.state.order.products[product].plank4.length - 5)
              planksRef.child(plank4).update({
                available: false,
                firstName: context.state.order.customer.firstName,
                lastName: context.state.order.customer.lastName
              })
            }
          } else if (context.state.order.products[product].name == "Schreibtisch"){
            let planksRef = db.ref("tableOfficePlanks");
            let plank1 = context.state.order.products[product].plank1.substring(0, context.state.order.products[product].plank1.length - 5)
            planksRef.child(plank1).update({
              available: false,
              firstName: context.state.order.customer.firstName,
              lastName: context.state.order.customer.lastName
            })
          } else if(context.state.order.products[product].name == "Regal"){
            let planksRef = db.ref("shelfPlanks");
            for (var i = 0; i < context.state.order.products[product].planks.length; i++){
              let plank = context.state.order.products[product].planks[i].substring(0, context.state.order.products[product].planks[i].length - 4)
              planksRef.child(plank).update({
                available: false,
                firstName: context.state.order.customer.firstName,
                lastName: context.state.order.customer.lastName
              })
            }

          } else if (context.state.order.products[product].name == "Bank"){
            let planksRef = db.ref("benchPlanks");
            let plank1 = context.state.order.products[product].plank1.substring(0, context.state.order.products[product].plank1.length - 4)
            planksRef.child(plank1).update({
              available: false,
              firstName: context.state.order.customer.firstName,
              lastName: context.state.order.customer.lastName
            })
          } else if (context.state.order.products[product].name == "Hocker"){
            let planksRef = db.ref("stoolPlanks");
            let plank1 = context.state.order.products[product].plank1.substring(0, context.state.order.products[product].plank1.length - 5)
            planksRef.child(plank1).update({
              available: false,
              firstName: context.state.order.customer.firstName,
              lastName: context.state.order.customer.lastName
            })
          }
        }
      }})
      context.dispatch("writeOrderID")
    },
    setNavbarActive(context, index){
      context.commit("SET_NAVBAR_ACTIVE", index)
    },
    sendMessage(context, message){
      db.ref("message").push(JSON.parse(JSON.stringify({
        order: context.state.order,
        message : message
      })))
    },
    changeCustomerInformation(context, customerInformation){
      context.commit("CHANGE_CUSTOMER_INFORMATION", customerInformation)
      context.commit("CALCULATE_TOTAL_PRICE")
    },
    deleteFromCart(context, index){
      context.commit("DELETE_FROM_CART", index)
      context.commit("CALCULATE_DISCOUNT")
      context.commit("CALCULATE_TOTAL_PRICE")
    },
    getOrderID(context){
      db.ref('orderID').once('value').then(function(snapshot) {
        var orderID = (snapshot.val()) + 1
        context.commit("SET_ORDERID", orderID)
      });
    },
    writeOrderID(context){
      db.ref("/").update({orderID: context.state.order.orderID})
    },

    changeBenchConfig(context, payload){
      switch (payload.change) {
        case 'length':
          context.commit("BENCH_CONFIG_LENGTH", payload.value)
          break;
       case 'dimensionType':
          context.commit("BENCH_CONFIG_DIMENSION_TYPE", payload.value)
          switch (payload.value){
            case 'twoPerson':
              context.commit("BENCH_CONFIG_LENGTH", context.state.benchConfig.dimensions.standardDimensions.twoPerson.length)
            break;
            case 'threePerson':
              context.commit("BENCH_CONFIG_LENGTH", context.state.benchConfig.dimensions.standardDimensions.threePerson.length)
            break;
            default:
            break
          }
          break;
       case 'frame':
          context.commit("BENCH_CONFIG_FRAME", payload.value)
          break;
       case 'color':
          context.commit("BENCH_CONFIG_COLOR", payload.value)
          break;
       case 'colorType':
          context.commit("BENCH_CONFIG_COLOR_TYPE", payload.value)
          break;
       case 'choosePlanks':
          context.commit("BENCH_CONFIG_CHOOSE_PLANKS", payload.value)
          break;
      case 'chooseColor':
         context.commit("BENCH_CONFIG_CHOOSE_COLOR", payload.value)
         break;
       case 'changePlank':
          context.dispatch("changeBenchPlank", payload.value)
          break;
        default:
          break;
      }
      context.dispatch("calculateBenchPrice")
    },
    changeBenchPlank(context, payload){
      var currentIndex = context.state.benchConfig.planks.used[payload.position].index
      if(payload.direction == 'up'){
        currentIndex += 1
      } else if(payload.direction == 'down'){
        currentIndex -= 1
      }
      context.commit("BENCH_SET_PLANK", {plank:payload.position, index:currentIndex})
      context.dispatch("checkBenchPlank")
    },
    checkBenchPlank(context){
      for (var j = 0; j < context.state.benchConfig.planks.used.length; j++){
        var currentIndex = context.state.benchConfig.planks.used[j].index
        var checkWhileLoop = true
        while (checkWhileLoop){
          currentIndex += 1
          checkWhileLoop = false
          for (var i = 0; i < context.state.benchConfig.planks.used.length; i++){
            if(currentIndex == context.state.benchConfig.planks.used[i].index){
              checkWhileLoop = true
            }
          }
        }
        if (currentIndex >= context.state.benchConfig.planks.availablePlanks.length){
          context.commit("BENCH_SET_PLANK_UP", {plank:j, upArrow:false})
        } else {
          context.commit("BENCH_SET_PLANK_UP", {plank:j, upArrow:true})
        }

        currentIndex = context.state.benchConfig.planks.used[j].index
        checkWhileLoop = true
        while (checkWhileLoop){
          currentIndex -= 1
          checkWhileLoop = false
          for (var k = 0; k < context.state.benchConfig.planks.used.length; k++){
            if(currentIndex == context.state.benchConfig.planks.used[k].index){
              checkWhileLoop = true
            }
          }
        }
        if (currentIndex < 0){
          context.commit("BENCH_SET_PLANK_DOWN", {plank:j, downArrow:false})
        } else {
          context.commit("BENCH_SET_PLANK_DOWN", {plank:j, downArrow:true})
        }
      }
    },
    calculateBenchPrice(context){
      var baseprice = context.state.benchConfig.baseprice
      var length = context.state.benchConfig.dimensions.length
      var frame = context.state.benchConfig.frameType
      // var choseOwnColor = context.state.tableConfig.color.chooseOwnColor
      // var colorType = context.state.tableConfig.color.appearance

      var price = baseprice + 2.5*(length - 100)

      if (frame == 'simple'){
        price += context.state.benchConfig.frameTypes.simple
      } else if (frame == 'massive'){
        price += context.state.benchConfig.frameTypes.massive
      }

      // if(choseOwnColor){
      //   price += 75
      // }
      //
      // if(colorType == 'glossy'){
      //   price += 25
      // }
      // var standardColorMatch = false
      // for(var i=0;i<context.state.standardColors.length;i++){
      //   if(context.state.standardColors[i].hex == context.state.benchConfig.color.hex){
      //     standardColorMatch = true
      //   }
      // }
      // if(!standardColorMatch) {
      //   price += 75
      // }

      if(context.state.benchConfig.planks.choosePlanks){
        price += context.state.benchConfig.planks.costForSelfPicking
      }

      if(context.state.benchConfig.color.chooseOwnColor){
        price += context.state.benchConfig.color.costForSelfPicking
      }

      if(context.state.benchConfig.dimensions.chosen == 'individual'){
        price += context.state.benchConfig.dimensions.costForIndividual
      }

      price = Math.round(price * context.state.priceMultiplicator)

      context.commit("BENCH_PRICE", price)
    },
    setBenchPlanks(context) {
      context.commit("BENCH_CLEAR_AVAILABLE_PLANKS")
      db.ref('/benchPlanks').once('value').then(function(snapshot) {
        var planks = (snapshot.val())
        for (var key in planks) {
          if (planks[key].available){
            var content = {name: planks[key].name, title: planks[key].title}
            context.commit("BENCH_ADD_AVAILABLE_PLANK", content)
          }
        }
        context.commit("BENCH_SET_PLANK", {plank:0, index:0})
        context.dispatch("checkBenchPlank")
      });

    },
    addBenchToCart(context){
      context.commit("ADD_TO_CART", "bench")
      context.commit("CALCULATE_DISCOUNT")
      context.commit("CALCULATE_TOTAL_PRICE")
    },

    addSampleToCart(context){
      context.commit("ADD_TO_CART", "sample")
      context.commit("CALCULATE_DISCOUNT")
      context.commit("CALCULATE_TOTAL_PRICE")
    },

    changeFrameConfig(context, payload){
      switch (payload.change) {
        case 'width':
          context.commit("FRAME_CONFIG_WIDTH", payload.value)
          break;
       case 'height':
         context.commit("FRAME_CONFIG_HEIGHT", payload.value)
         break;
       case 'passepartoutColor':
         context.commit("FRAME_CONFIG_PASSEPARTOUT_COLOR", payload.value)
         break;
       case 'filling':
          context.commit("FRAME_CONFIG_FILLING", payload.value)
          break;
      }
      context.dispatch("calculateFramePrice")
    },
    calculateFramePrice(context){
      var baseprice = context.state.frameConfig.baseprice
      var width = context.state.frameConfig.dimensions.width
      var height = context.state.frameConfig.dimensions.height
      var fillingPriceFaktor = 1

      switch (context.state.frameConfig.filling.type){
        case 'none':
          fillingPriceFaktor = context.state.frameConfig.filling.none.additionalPriceFaktor
          break;
        case 'whiteboard':
          fillingPriceFaktor = context.state.frameConfig.filling.whiteboard.additionalPriceFaktor
          break;
        case 'blackboard':
          fillingPriceFaktor = context.state.frameConfig.filling.blackboard.additionalPriceFaktor
          break;
        case 'mirror':
          fillingPriceFaktor = context.state.frameConfig.filling.mirror.additionalPriceFaktor
          break;
        case 'passepartout':
          fillingPriceFaktor = context.state.frameConfig.filling.passepartout.additionalPriceFaktor
          break;
        default:
          break;
      }

      var price = (baseprice + (width - 20)/1.5 + (height - 20)/1.5) * fillingPriceFaktor

      price = Math.round(price * context.state.priceMultiplicator)

      context.commit("FRAME_PRICE", price)
    },
    addFrameToCart(context){
      context.commit("ADD_TO_CART", "frame")
      context.commit("CALCULATE_DISCOUNT")
      context.commit("CALCULATE_TOTAL_PRICE")
    },

    changeStoolConfig(context, payload){
      switch (payload.change) {
        case 'height':
          context.commit("STOOL_CONFIG_HEIGHT", payload.value)
          break;
        case 'dimensionType':
           context.commit("STOOL_CONFIG_DIMENSION_TYPE", payload.value)
           switch (payload.value){
             case 'normal':
               context.commit("STOOL_CONFIG_HEIGHT", context.state.stoolConfig.dimensions.standardDimensions.normal.height)
             break;
             case 'high':
               context.commit("STOOL_CONFIG_HEIGHT", context.state.stoolConfig.dimensions.standardDimensions.high.height)
             break;
             default:
             break
           }
           break;
       case 'frame':
          context.commit("STOOL_CONFIG_FRAME", payload.value)
          break;
       case 'color':
          context.commit("STOOL_CONFIG_COLOR", payload.value)
          break;
       case 'colorType':
          context.commit("STOOL_CONFIG_COLOR_TYPE", payload.value)
          break;
       case 'choosePlanks':
          context.commit("STOOL_CONFIG_CHOOSE_PLANKS", payload.value)
          break;
      case 'chooseColor':
         context.commit("STOOL_CONFIG_CHOOSE_COLOR", payload.value)
         break;
       case 'changePlank':
          context.dispatch("changeStoolPlank", payload.value)
          break;
        default:
          break;
      }
      context.dispatch("calculateStoolPrice")
    },
    changeStoolPlank(context, payload){
      var currentIndex = context.state.stoolConfig.planks.used[payload.position].index
      if(payload.direction == 'up'){
        currentIndex += 1
      } else if(payload.direction == 'down'){
        currentIndex -= 1
      }
      context.commit("STOOL_SET_PLANK", {plank:payload.position, index:currentIndex})
      context.dispatch("checkStoolPlank")
    },
    checkStoolPlank(context){
      for (var j = 0; j < context.state.stoolConfig.planks.used.length; j++){
        var currentIndex = context.state.stoolConfig.planks.used[j].index
        var checkWhileLoop = true
        while (checkWhileLoop){
          currentIndex += 1
          checkWhileLoop = false
          for (var i = 0; i < context.state.stoolConfig.planks.used.length; i++){
            if(currentIndex == context.state.stoolConfig.planks.used[i].index){
              checkWhileLoop = true
            }
          }
        }
        if (currentIndex >= context.state.stoolConfig.planks.availablePlanks.length){
          context.commit("STOOL_SET_PLANK_UP", {plank:j, upArrow:false})
        } else {
          context.commit("STOOL_SET_PLANK_UP", {plank:j, upArrow:true})
        }

        currentIndex = context.state.stoolConfig.planks.used[j].index
        checkWhileLoop = true
        while (checkWhileLoop){
          currentIndex -= 1
          checkWhileLoop = false
          for (var k = 0; k < context.state.stoolConfig.planks.used.length; k++){
            if(currentIndex == context.state.stoolConfig.planks.used[k].index){
              checkWhileLoop = true
            }
          }
        }
        if (currentIndex < 0){
          context.commit("STOOL_SET_PLANK_DOWN", {plank:j, downArrow:false})
        } else {
          context.commit("STOOL_SET_PLANK_DOWN", {plank:j, downArrow:true})
        }
      }
    },
    calculateStoolPrice(context){
      var baseprice = context.state.stoolConfig.baseprice
      var height = context.state.stoolConfig.dimensions.height
      var frame = context.state.stoolConfig.frameType
      // var choseOwnColor = context.state.tableConfig.color.chooseOwnColor
      // var colorType = context.state.tableConfig.color.appearance

      var price = baseprice + 2.5*(height - 45)

      if (frame == 'simple'){
        price += context.state.stoolConfig.frameTypes.simple
      } else if (frame == 'massive'){
        price += context.state.stoolConfig.frameTypes.massive
      }

      // if(choseOwnColor){
      //   price += 75
      // }
      //
      // if(colorType == 'glossy'){
      //   price += 25
      // }
      // var standardColorMatch = false
      // for(var i=0;i<context.state.standardColors.length;i++){
      //   if(context.state.standardColors[i].hex == context.state.benchConfig.color.hex){
      //     standardColorMatch = true
      //   }
      // }
      // if(!standardColorMatch) {
      //   price += 75
      // }

      if(context.state.stoolConfig.planks.choosePlanks){
        price += context.state.stoolConfig.planks.costForSelfPicking
      }

      if(context.state.stoolConfig.color.chooseOwnColor){
        price += context.state.stoolConfig.color.costForSelfPicking
      }

      if(context.state.stoolConfig.dimensions.chosen == 'individual'){
        price += context.state.stoolConfig.dimensions.costForIndividual
      }

      price = Math.round(price * context.state.priceMultiplicator)

      context.commit("STOOL_PRICE", price)
    },
    setStoolPlanks(context) {
      context.commit("STOOL_CLEAR_AVAILABLE_PLANKS")
      db.ref('/stoolPlanks').once('value').then(function(snapshot) {
        var planks = (snapshot.val())
        for (var key in planks) {
          if (planks[key].available){
            var content = {name: planks[key].name, title: planks[key].title}
            context.commit("STOOL_ADD_AVAILABLE_PLANK", content)
          }
        }
        context.commit("STOOL_SET_PLANK", {plank:0, index:0})
        context.dispatch("checkStoolPlank")
      });
    },
    addStoolToCart(context){
      context.commit("ADD_TO_CART", "stool")
      context.commit("CALCULATE_DISCOUNT")
      context.commit("CALCULATE_TOTAL_PRICE")
    },

    changeTableConfig(context, payload){
      switch (payload.change) {
        case 'length':
          context.commit("TABLE_CONFIG_LENGTH", payload.value)
          break;
        case 'width':
          context.commit("TABLE_CONFIG_WIDTH", payload.value)
          context.dispatch("checkTableActivePlanks")
          break;
        case 'height':
          context.commit("TABLE_CONFIG_HEIGHT", payload.value)
          break;
       case 'dimensionType':
          context.commit("TABLE_CONFIG_DIMENSION_TYPE", payload.value)
          switch (payload.value){
            case 'dining':
              context.commit("TABLE_CONFIG_LENGTH", context.state.tableConfig.dimensions.standardDimensions.dining.length)
              context.commit("TABLE_CONFIG_WIDTH", context.state.tableConfig.dimensions.standardDimensions.dining.width)
              context.commit("TABLE_CONFIG_HEIGHT", context.state.tableConfig.dimensions.standardDimensions.dining.height)
            break;
            case 'office':
              context.commit("TABLE_CONFIG_LENGTH", context.state.tableConfig.dimensions.standardDimensions.office.length)
              context.commit("TABLE_CONFIG_WIDTH", context.state.tableConfig.dimensions.standardDimensions.office.width)
              context.commit("TABLE_CONFIG_HEIGHT", context.state.tableConfig.dimensions.standardDimensions.office.height)
            break;
            default:
            break
          }
          break;
       case 'frame':
          context.commit("TABLE_CONFIG_FRAME", payload.value)
          break;
       case 'tableTop':
          context.commit("TABLE_CONFIG_TABLE_TOP", payload.value)
          break;
       case 'color':
          context.commit("TABLE_CONFIG_COLOR", payload.value)
          break;
       case 'colorType':
          context.commit("TABLE_CONFIG_COLOR_TYPE", payload.value)
          break;
       case 'choosePlanks':
          context.commit("TABLE_CONFIG_CHOOSE_PLANKS", payload.value)
          break;
      case 'chooseColor':
         context.commit("TABLE_CONFIG_CHOOSE_COLOR", payload.value)
         break;
       case 'changePlank':
          context.dispatch("changeTablePlank", payload.value)
          break;
        default:
          break;
      }
      context.dispatch("calculateTablePrice")
    },
    changeTablePlank(context, payload){
      var currentIndex = context.state.tableConfig.planks.used[payload.position].index
      var checkWhileLoop = true
      while (checkWhileLoop){
        if(payload.direction == 'up'){
          currentIndex += 1
        } else if(payload.direction == 'down'){
          currentIndex -= 1
        }
        checkWhileLoop = false
        for (var i = 0; i < context.state.tableConfig.planks.used.length; i++){
          if(currentIndex == context.state.tableConfig.planks.used[i].index){
            checkWhileLoop = true
          }
        }
      }
      context.commit("TABLE_SET_PLANK", {plank:payload.position, index:currentIndex})
      context.dispatch("checkTablePlank")
    },
    checkTablePlank(context){
      for (var j = 0; j < context.state.tableConfig.planks.used.length; j++){
        var currentIndex = context.state.tableConfig.planks.used[j].index
        var checkWhileLoop = true
        while (checkWhileLoop){
          currentIndex += 1
          checkWhileLoop = false
          for (var i = 0; i < context.state.tableConfig.planks.used.length; i++){
            if(currentIndex == context.state.tableConfig.planks.used[i].index){
              checkWhileLoop = true
            }
          }
        }
        if (currentIndex >= context.state.tableConfig.planks.availablePlanks.length){
          context.commit("TABLE_SET_PLANK_UP", {plank:j, upArrow:false})
        } else {
          context.commit("TABLE_SET_PLANK_UP", {plank:j, upArrow:true})
        }

        currentIndex = context.state.tableConfig.planks.used[j].index
        checkWhileLoop = true
        while (checkWhileLoop){
          currentIndex -= 1
          checkWhileLoop = false
          for (var k = 0; k < context.state.tableConfig.planks.used.length; k++){
            if(currentIndex == context.state.tableConfig.planks.used[k].index){
              checkWhileLoop = true
            }
          }
        }
        if (currentIndex < 0){
          context.commit("TABLE_SET_PLANK_DOWN", {plank:j, downArrow:false})
        } else {
          context.commit("TABLE_SET_PLANK_DOWN", {plank:j, downArrow:true})
        }
      }
    },
    checkTableActivePlanks(context){
      var width = context.state.tableConfig.dimensions.width
      var activePlanks = []
      switch(true){
        case (width <= 55):
          activePlanks = {numberOfPlanks: 2, active: [true, true, false, false]}
          context.commit("TABLE_CONFIG_ACTIVE_PLANKS", activePlanks)
          break;
        case (width <= 82):
          activePlanks = {numberOfPlanks: 3, active: [true, true, true, false]}
          context.commit("TABLE_CONFIG_ACTIVE_PLANKS", activePlanks)
          break;
        default:
          activePlanks = {numberOfPlanks: 4, active: [true, true, true, true]}
          context.commit("TABLE_CONFIG_ACTIVE_PLANKS", activePlanks)
          break;
      }
    },
    calculateTablePrice(context){
      var baseprice = context.state.tableConfig.baseprice
      var length = context.state.tableConfig.dimensions.length
      var width = context.state.tableConfig.dimensions.width
      var height = context.state.tableConfig.dimensions.height
      var frame = context.state.tableConfig.frameType
      var tableTop = context.state.tableConfig.tableTop
      // var choseOwnColor = context.state.tableConfig.color.chooseOwnColor
      // var colorType = context.state.tableConfig.color.appearance

      var price = baseprice + 2.5*(length - 100) + 2.5*(width - 50) + 2.5*(height - 45)

      price += (context.state.tableConfig.planks.numberOfPlanks - 2) * 75

      price = Math.round(price * context.state.priceMultiplicator)

      if (frame == 'closed'){
        price += context.state.tableConfig.frameTypes.closed
      } else if (frame == 'diagonal'){
        price += context.state.tableConfig.frameTypes.diagonal
      }

      if (tableTop == 'solid'){
        price += context.state.tableConfig.tableTopTypes.solid
      }

      if(context.state.tableConfig.planks.choosePlanks){
        price += context.state.tableConfig.planks.costForSelfPicking
      }

      if(context.state.tableConfig.color.chooseOwnColor){
        price += context.state.tableConfig.color.costForSelfPicking
      }

      if(context.state.tableConfig.dimensions.chosen == 'individual'){
        price += context.state.tableConfig.dimensions.costForIndividual
      }

      context.commit("TABLE_PRICE", price)
    },
    calculateTableOfficePrice(context){
      var baseprice = context.state.tableOfficeConfig.baseprice

      var price = baseprice

      price = Math.round(price * context.state.priceMultiplicator)

      context.commit("TABLE_OFFICE_PRICE", price)
    },
    setTablePlanks(context) {
      context.commit("TABLE_CLEAR_AVAILABLE_PLANKS")
      db.ref('/planks').once('value').then(function(snapshot) {
        var planks = (snapshot.val())
        for (var key in planks) {
          if (planks[key].available){
            var content = {name: planks[key].name, title: planks[key].title}
            context.commit("TABLE_ADD_AVAILABLE_PLANK", content)
          }
        }
        context.commit("TABLE_SET_PLANK", {plank:0, index:0})
        context.commit("TABLE_SET_PLANK", {plank:1, index:1})
        context.commit("TABLE_SET_PLANK", {plank:2, index:2})
        context.commit("TABLE_SET_PLANK", {plank:3, index:3})
        context.dispatch("checkTablePlank")
      });
    },
    addTableToCart(context){
      context.commit("ADD_TO_CART", "table")
      context.commit("CALCULATE_DISCOUNT")
      context.commit("CALCULATE_TOTAL_PRICE")
    },

    changeTableOfficeConfig(context, payload){
      switch (payload.change) {
       case 'color':
          context.commit("TABLE_OFFICE_CONFIG_COLOR", payload.value)
          break;
       case 'changePlank':
          context.dispatch("changeTableOfficePlank", payload.value)
          break;
        default:
          break;
      }
    },
    changeTableOfficePlank(context, payload){
      var currentIndex = context.state.tableOfficeConfig.planks.used[payload.position].index
      var checkWhileLoop = true
      while (checkWhileLoop){
        if(payload.direction == 'up'){
          currentIndex += 1
        } else if(payload.direction == 'down'){
          currentIndex -= 1
        }
        checkWhileLoop = false
        for (var i = 0; i < context.state.tableOfficeConfig.planks.used.length; i++){
          if(currentIndex == context.state.tableOfficeConfig.planks.used[i].index){
            checkWhileLoop = true
          }
        }
      }
      context.commit("TABLE_OFFICE_SET_PLANK", {plank:payload.position, index:currentIndex})
      context.dispatch("checkTableOfficePlank")
    },
    checkTableOfficePlank(context){
      for (var j = 0; j < context.state.tableOfficeConfig.planks.used.length; j++){
        var currentIndex = context.state.tableOfficeConfig.planks.used[j].index
        var checkWhileLoop = true
        while (checkWhileLoop){
          currentIndex += 1
          checkWhileLoop = false
          for (var i = 0; i < context.state.tableOfficeConfig.planks.used.length; i++){
            if(currentIndex == context.state.tableOfficeConfig.planks.used[i].index){
              checkWhileLoop = true
            }
          }
        }
        if (currentIndex >= context.state.tableOfficeConfig.planks.availablePlanks.length){
          context.commit("TABLE_OFFICE_SET_PLANK_UP", {plank:j, upArrow:false})
        } else {
          context.commit("TABLE_OFFICE_SET_PLANK_UP", {plank:j, upArrow:true})
        }

        currentIndex = context.state.tableOfficeConfig.planks.used[j].index
        checkWhileLoop = true
        while (checkWhileLoop){
          currentIndex -= 1
          checkWhileLoop = false
          for (var k = 0; k < context.state.tableOfficeConfig.planks.used.length; k++){
            if(currentIndex == context.state.tableOfficeConfig.planks.used[k].index){
              checkWhileLoop = true
            }
          }
        }
        if (currentIndex < 0){
          context.commit("TABLE_OFFICE_SET_PLANK_DOWN", {plank:j, downArrow:false})
        } else {
          context.commit("TABLE_OFFICE_SET_PLANK_DOWN", {plank:j, downArrow:true})
        }
      }
    },
    setTableOfficePlanks(context) {
      context.commit("TABLE_OFFICE_CLEAR_AVAILABLE_PLANKS")
      db.ref('/tableOfficePlanks').once('value').then(function(snapshot) {
        var planks = (snapshot.val())
        for (var key in planks) {
          if (planks[key].available){
            var content = {name: planks[key].name, title: planks[key].title}
            context.commit("TABLE_OFFICE_ADD_AVAILABLE_PLANK", content)
          }
        }
        context.commit("TABLE_OFFICE_SET_PLANK", {plank:0, index:0})
        context.dispatch("checkTableOfficePlank")
      });
    },
    addTableOfficeToCart(context){
      context.commit("ADD_TO_CART", "tableOffice")
      context.commit("CALCULATE_DISCOUNT")
      context.commit("CALCULATE_TOTAL_PRICE")
    },

    changeShelfConfig(context, payload){
      switch (payload.change) {
        case 'width':
          context.commit("SHELF_CONFIG_WIDTH", payload.value)
          break;
        case 'height':
          context.commit("SHELF_CONFIG_HEIGHT", payload.value)
          context.commit("SHELF_SET_EVEN_SPACE_BETWEEN_PLANKS")
          break;
       case 'numberOfPillars':
          context.commit("SHELF_CONFIG_NUMBER_OF_PILLOWS", payload.value)
          break;
       case 'distanceLeftMiddle':
          context.commit("SHELF_CONFIG_DISTANCE_LEFT_MIDDLE", payload.value)
          break;
       case 'distanceTopToFirstPlank':
          context.commit("SHELF_CONFIG_DISTANCE_TOP_TO_FIRST_PLANK", payload.value)
          break;
        default:
          break;
      }
      context.dispatch("calculateShelfPrice")
    },
    changeShelfPlank(context, payload){
      var currentIndex = context.state.shelfConfig.planks.active.planks[payload.position].index
      var checkWhileLoop = true
      while (checkWhileLoop){
        if(payload.direction == 'up'){
          currentIndex += 1
        } else if(payload.direction == 'down'){
          currentIndex -= 1
        }
        checkWhileLoop = false
        for (var i = 0; i < context.state.shelfConfig.planks.active.planks.length; i++){
          if(currentIndex == context.state.shelfConfig.planks.active.planks[i].index){
            checkWhileLoop = true
          }
        }
      }
      context.commit("SHELF_SET_PLANK", {plank:payload.position, index:currentIndex})
      context.commit("SHELF_SET_ACTIVE_PLANK", {plank:payload.position, index:currentIndex})
      context.dispatch("checkShelfPlank")
      context.dispatch("calculateShelfPrice")
    },
    checkShelfPlank(context){
      for (var j = 0; j < context.state.shelfConfig.planks.active.planks.length; j++){
        var currentIndex = context.state.shelfConfig.planks.active.planks[j].index
        var checkWhileLoop = true
        while (checkWhileLoop){
          currentIndex += 1
          checkWhileLoop = false
          for (var i = 0; i < context.state.shelfConfig.planks.active.planks.length; i++){
            if(currentIndex == context.state.shelfConfig.planks.active.planks[i].index){
              checkWhileLoop = true
            }
          }
        }
        if (currentIndex >= context.state.shelfConfig.planks.availablePlanks.length){
          context.commit("SHELF_SET_PLANK_UP", {plank:j, upArrow:false})
        } else {
          context.commit("SHELF_SET_PLANK_UP", {plank:j, upArrow:true})
        }

        currentIndex = context.state.shelfConfig.planks.active.planks[j].index
        checkWhileLoop = true
        while (checkWhileLoop){
          currentIndex -= 1
          checkWhileLoop = false
          for (var k = 0; k < context.state.shelfConfig.planks.active.planks.length; k++){
            if(currentIndex == context.state.shelfConfig.planks.active.planks[k].index){
              checkWhileLoop = true
            }
          }
        }
        if (currentIndex < 0){
          context.commit("SHELF_SET_PLANK_DOWN", {plank:j, downArrow:false})
        } else {
          context.commit("SHELF_SET_PLANK_DOWN", {plank:j, downArrow:true})
        }
      }
    },
    changeShelfNumberOfPlanks(context, number) {
      switch (number){
        case 'init':
          // context.commit("SHELF_CLEAR_ACTIVE_PLANKS")
          // for (var i=0 ; i < context.state.shelfConfig.planks.active.numberOfPlanksInit ; i++){
          //   context.commit("SHELF_SET_NUMBER_OF_ACTIVE_PLANKS", i+1)
          //   context.commit("SHELF_ADD_ACTIVE_PLANK")
          //   context.commit("SHELF_SET_EVEN_SPACE_BETWEEN_PLANKS")
          // }
          break;
        case '+':
            context.commit("SHELF_SET_NUMBER_OF_ACTIVE_PLANKS", '+')
            context.commit("SHELF_ADD_ACTIVE_PLANK")
            context.commit("SHELF_SET_EVEN_SPACE_BETWEEN_PLANKS")
          break;
        case '-':
            context.commit("SHELF_SET_NUMBER_OF_ACTIVE_PLANKS", '-')
            context.commit("SHELF_SUBTRACT_ACTIVE_PLANK")
            context.commit("SHELF_SET_EVEN_SPACE_BETWEEN_PLANKS")
          break;
        default:
          break;
      }
      context.dispatch("calculateShelfPrice")
    },
    setShelfPlanks(context) {
      context.commit("SHELF_CLEAR_AVAILABLE_PLANKS")
      db.ref('/shelfPlanks').once('value').then(function(snapshot) {
        var planks = (snapshot.val())
        for (var key in planks) {
          if (planks[key].available){
            var content = {name: planks[key].name, title: planks[key].title}
            context.commit("SHELF_ADD_AVAILABLE_PLANK", content)
          }
        }
        context.dispatch("changeShelfNumberOfPlanks", 'init')
        context.dispatch("checkShelfPlank")
      });
    },
    setShelfActivePlanks(context){
      for (var i = 0; i < context.state.shelfConfig.planks.active.numberOfPlanks ; i++){
        context.commit("SHELF_SET_ACTIVE_PLANK", {plank:i, index:i})
      }
      context.dispatch("checkShelfPlank")
      context.dispatch("calculateShelfPrice")
    },
    deleteShelfActivePlanks(context){
      for (var i = 0; i < context.state.shelfConfig.planks.active.numberOfPlanks ; i++){
        context.commit("SHELF_DELETE_ACTIVE_PLANK_NAME", i)
      }
      context.dispatch("calculateShelfPrice")
    },
    addShelfToCart(context){
      context.commit("ADD_TO_CART", "shelf")
      context.commit("CALCULATE_DISCOUNT")
      context.commit("CALCULATE_TOTAL_PRICE")
    },
    changeShelfChooseColor(context, chooseColor){
      context.commit("SHELF_CONFIG_CHOOSE_COLOR", chooseColor)
      context.dispatch("calculateShelfPrice")
    },
    changeShelfColor(context, color){
      context.commit("SHELF_CONFIG_COLOR", color)
    },
    calculateShelfPrice(context){
      var baseprice = context.state.shelfConfig.baseprice
      var width = context.state.shelfConfig.dimensions.width
      var height = context.state.shelfConfig.dimensions.height
      var numberOfPillars = context.state.shelfConfig.dimensions.numberOfPillows
      var numberOfPlanks = context.state.shelfConfig.planks.active.planks.length
      var shippingVariable = 0

      if (width > height){
        shippingVariable = width
      } else {
        shippingVariable = height
      }

      var price = Math.round(context.state.priceMultiplicator*(200+1.1*(1.19*(baseprice + 2.5*(width - 60) + 2.5*(height - 50) + 70*(numberOfPlanks-2) + 100*(numberOfPillars-2))+shippingVariable)))

      context.commit("SHELF_PRICE", price)
    },

    setLanguage(context, language){
      context.commit("SET_LANGUAGE", language)
    }
  },
  getters: {
    getOutsideGermany(state){return state.order.customer.outsideGermany},
    getExpressBuild(state){return state.order.customer.expressBuild},
    getAnimationProperties(state){return state.animationProperties},
    getFooter(state){return state.footer},
    getReviews(state){return state.reviews},
    getNavbarActive(state){return state.navbarActive},
    getText(state){
      if(state.language == "EN"){
        return state.textsEnglish
      } else {
        return state.texts
      }
    },
    getLanguage(state){return state.language},
    getTablePictureSources(state){return state.picturesSource.table},
    getTableOfficePictureSources(state){return state.picturesSource.tableOffice},
    getShelfPictureSources(state){return state.picturesSource.shelf},
    getBenchPictureSources(state){return state.picturesSource.bench},
    getFramePictureSources(state){return state.picturesSource.frame},
    getStoolPictureSources(state){return state.picturesSource.stool},
    getTableConfig(state){return state.tableConfig},
    getTableOfficeConfig(state){return state.tableOfficeConfig},
    getShelfConfig(state){return state.shelfConfig},
    getBenchConfig(state){return state.benchConfig},
    getFrameConfig(state){return state.frameConfig},
    getStoolConfig(state){return state.stoolConfig},
    getColorTypes(state){return state.standardColors},
    getOrder(state){return state.order},
    getCustomerInformation(state){return state.order.customer},
    getSustainabilityNumbers(state){return state.sustainabilityNumbers},
    getVoucher(state){return state.voucher},
    getShippingCost(state){return state.shippingAndDiscount.shippingCost},
    getSavedOrder(){ return new Promise((resolve) => {
        db.ref('orderPendingStripe').once('value').then(function (snapshot){
          resolve(snapshot.val());
        });
      })
    },
  }
})
